// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:37:20.218Z
// Property: Patriot Apts. (ID: 6767906449165618)
// Collections: 37 amenities, 7 floorplans (live), 30 photos, 66 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165618",
  "property_external_id": "rn34yx2",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/patriot-apts-el-paso-tx/rn34yx2/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Patriot+Apartments/data=!4m2!3m1!1s0x0:0xa47b692c4925f4d?sa=X&ved=2ahUKEwi3_v-a_bySAxWWN2IAHf1nKvcQ_BJ6BAg8EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "8442932380",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "patriot-apts.",
  "property_name": "Patriot Apts.",
  "property_website_url": "https://www.caseusa.com/apartments/tx/el-paso/patriot-apts/",
  "property_domain": null,
  "property_address": "4600 Fairbanks",
  "property_full_address": "4600 Fairbanks, El Paso, TX, 79924",
  "property_address_1": "4600 Fairbanks",
  "property_address_2": null,
  "property_address_city": "El Paso",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "79924",
  "property_address_country": "US",
  "property_address_county": "El Paso County",
  "property_neighborhood_address": "Terrace Hills",
  "property_address_latitude": "31.903",
  "property_address_longitude": "-106.4391",
  "property_email": "thepatriot@caseusa.com",
  "property_phone": "(915) 336-8182",
  "property_call_tracking_phone": "855-460-1231",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Patriot Apts. in vibrant El Paso, Texas, elevate your lifestyle with spacious one, two, and three-bedroom layouts. Enjoy an array of amenities including a refreshing pool, state-of-the-art fitness center, and a welcoming clubhouse. Your perfect home awaits—check availability or schedule your visit today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Welcome to Patriot Apartments in El Paso, Texas!** Discover a vibrant community designed to suit all lifestyles with our thoughtfully curated floor plans offering one, two, and three-bedroom apartments. Each unit is equipped with modern amenities to elevate your living experience, including spacious walk-in closets, fully equipped kitchens with microwaves, dishwashers, and even washer/dryer hookups. Enjoy the comfort of air conditioning and ceiling fans, while staying connected with high-speed internet access and cable readiness.\n\nOur community is tailored for relaxation and recreation, featuring a sparkling pool, a well-equipped fitness center, and a basketball court for fitness enthusiasts. Families will love our playground and picnic area, while pet owners can let their furry friends roam in our dedicated pet play area. Engage with neighbors at planned social activities in our inviting clubhouse or take advantage of our business center and conference rooms for work-related needs.\n\nPatriot Apartments also offer convenience with on-site maintenance, a property manager available for your needs, and online services for hassle-free living. Relax and unwind in the recreation room or enjoy the outdoors at the grill area. With easy access to laundry facilities and a package service for your deliveries, everything you need is at your fingertips.\n\nDon't miss out on the life you've always wanted! Explore our available apartments today and envision your future at Patriot Apartments. Schedule a tour and let us help you find your new home!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-2e73-7192-bc47-cd90f31f3e09.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment community dog park with grass and play structures.",
    "public_id": "019cfb44-2e73-7192-bc47-cd90f31f3e09",
    "storage_key": "property/6767906449165618/019cfb44-2e73-7192-bc47-cd90f31f3e09.webp",
    "width": 2700,
    "height": 1800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "320",
  "property_year_built": "1994",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.25",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Pets are restricted to those weighing between 1-80 lbs.",
  "property_pet_policy_description": "Above applies to pets 1-80 lbs",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://patriotapartmentselpaso.securecafe.com/onlineleasing/patriot-apts/floorplans.aspx",
  "property_resident_portal_url": "https://patriotapartmentselpaso.securecafe.com/residentservices/patriot-apts/userlogin.aspx",
  "property_apply_now_url": "https://patriotapartmentselpaso.securecafe.com/onlineleasing/patriot-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-ac8c-7015-a1c2-b632355dee8b.webp",
  "property_primary_logo_media": {
    "alt_text": "The Patriot Apartments logo.",
    "public_id": "019cfb44-ac8c-7015-a1c2-b632355dee8b",
    "storage_key": "property/6767906449165618/019cfb44-ac8c-7015-a1c2-b632355dee8b.webp",
    "width": 300,
    "height": 150
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb45-bc01-727d-8408-d552eaf178f8.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb45-bc01-727d-8408-d552eaf178f8",
    "storage_key": "property/6767906449165618/019cfb45-bc01-727d-8408-d552eaf178f8.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb45-c91f-70f7-964f-53fa042417af.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Patriot Apartments logo",
    "public_id": "019cfb45-c91f-70f7-964f-53fa042417af",
    "storage_key": "property/6767906449165618/019cfb45-c91f-70f7-964f-53fa042417af.webp",
    "width": 300,
    "height": 150
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb45-d3c2-7499-a5fc-8be767608d78.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Patriot Apartments logo",
    "public_id": "019cfb45-d3c2-7499-a5fc-8be767608d78",
    "storage_key": "property/6767906449165618/019cfb45-d3c2-7499-a5fc-8be767608d78.webp",
    "width": 300,
    "height": 150
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#1d2f5d",
  "property_secondary_color": "#1c4587",
  "property_font_color": null,
  "property_color_4": "#af2024",
  "property_color_3": "#399fd1",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "655 - 1070",
  "property_sqft_min": "655",
  "property_sqft_max": "1070",
  "property_price_range": "1009 - 1545",
  "property_price_min": "1009",
  "property_price_max": "1545",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/thepatriotapartments/",
  "property_instagram_url": "https://www.instagram.com/the_patriot_apartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJtfqrjlRR54YRTV-SxJK2Rwo",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/the-patriot-apartments-el-paso-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Patriot Apts.",
  "property_home_romance_title": "Experience the Joy of Your New Apartment Community Today",
  "property_home_amenities_blurb": "At Patriot Apartments in El Paso, luxury meets convenience. Choose from stylish one, two, or three-bedroom floor plans, and enjoy exceptional amenities like a refreshing pool, fitness center, and pet play area. With social activities and online services, your perfect blend of leisure and comfort awaits—come see for yourself!",
  "property_home_floorplans_blurb": "Welcome to Patriot Apts. in vibrant El Paso, Texas, where comfort meets style. Choose from thoughtfully designed one, two, or three-bedroom floor plans that cater to your unique lifestyle. Embrace spacious living and modern amenities—your ideal apartment awaits. Browse our available homes and uncover the perfect fit today!",
  "property_home_gallery_blurb": "Welcome to Patriot Apts. in El Paso, Texas, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans, and indulge in exceptional amenities like a refreshing pool, fitness center, and vibrant playground. Picture yourself enjoying cozy gatherings in the clubhouse or unwinding in your stylish apartment today!",
  "property_home_neighborhood_blurb": "At Patriot Apts. in El Paso, your new home offers spacious one, two, and three-bedroom floor plans, framed by a vibrant community. Step outside to discover a wealth of local gems, from the El Paso Museum of Archaeology to the scenic trails of Franklin Mountains State Park. Embrace life where convenience meets adventure!",
  "property_home_reviews_blurb": "At Patriot Apts. in El Paso, our residents highly praise our exceptional staff, with one resident noting, \"the maintenance personnel are friendly and respectful.\" Enjoy a welcoming community where dedicated team members ensure your comfort and satisfaction. Join us and feel the difference that top-notch service makes in apartment living!",
  "property_neighborhood_blurb": "At Patriot Apts., immerse yourself in a vibrant El Paso neighborhood brimming with culture and recreation. Enjoy nearby destinations like Franklin Mountains State Park, the El Paso Museum of Archaeology, and the Fort Bliss Museum. Experience convenience with access to shopping at Lowe's and enriching visits to the El Paso Public Library. ",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Patriot Apartments in vibrant El Paso, Texas, luxury and comfort meet in a variety of floor plans, from one to three bedrooms. Enjoy our inviting pool, modern fitness center, and welcoming playground. With on-site maintenance, social activities, and pet-friendly spaces, your ideal lifestyle is just a visit away!",
  "property_applynow_blurb": "At Patriot Apartments in El Paso, enjoy versatile floor plans, from cozy one-bedroom to spacious three-bedroom layouts. Indulge in amenities like a refreshing pool, modern fitness center, and vibrant playground. With planned social activities and pet-friendly spaces, life here is enriching and engaging. Find your new home and lease online today!",
  "property_contactus_blurb": "At Patriot Apts. in El Paso, Texas, our thoughtfully designed floor plans cater to every lifestyle, offering cozy one, spacious two, and luxurious three-bedroom options. Whether you're seeking tranquility or vibrant community vibes, we have the perfect space for you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Patriot Apts. in vibrant El Paso, Texas, we cater to your lifestyle with a selection of one, two, and three-bedroom floor plans that suit every need. Curious about our community? Our Frequently Asked Questions page holds the keys to your inquiries—dive in and unlock your new home!",
  "property_floorplans_blurb": "At Patriot Apts. in El Paso, Texas, variety meets comfort with our thoughtfully designed floor plans. Choose from cozy one-bedroom, spacious two-bedroom, or expansive three-bedroom options tailored to fit your lifestyle. Uncover your ideal apartment home today and experience the perfect blend of style and functionality!",
  "property_gallery_blurb": "Immerse yourself in the vibrant community of Patriot Apts. in El Paso, Texas, where modern living meets comfort. Choose from spacious one to three-bedroom floor plans, and indulge in top-notch amenities like a sparkling pool, fitness center, and pet-friendly play areas. Picture yourself living here! ",
  "property_interactivemap_blurb": "At Patriot Apartments in vibrant El Paso, Texas, enjoy spacious one, two, and three-bedroom floor plans tailored to your lifestyle. With amenities like a refreshing pool, state-of-the-art fitness center, and a pet-friendly playground, your perfect home awaits. Use our interactive community map to find your ideal living space today!",
  "property_pets_blurb": "At Patriot Apartments in El Paso, TX, experience a harmonious blend of modern living and vibrant community life. Our spacious homes accommodate pets up to 80 lbs, fostering a welcoming environment for you and your furry companions. Embrace the charm and warmth of our residents while enjoying unparalleled amenities.",
  "property_referafriend_blurb": "At Patriot Apts. in El Paso, TX, spacious one, two, and three-bedroom floor plans await your unique touch. Great friends make great neighbors—invite someone special to share the journey here. Refer a friend today and experience community living redefined, where comfort and camaraderie come together harmoniously!",
  "property_residentaccess_blurb": "Welcome to Patriot Apts. in El Paso, Texas, where your ideal living space awaits! Choose from thoughtfully designed one, two, or three-bedroom floor plans tailored for comfort and style. Access your resident portal now to pay rent, schedule maintenance, and enhance your community experience effortlessly!",
  "property_reviews_blurb": "At Patriot Apartments in El Paso, our residents consistently praise our dedicated team. One happy resident shared, \"The maintenance personnel are friendly and respectful... They know what they're doing.\" Experience exceptional service and a welcoming community—see what our residents have to say about living at our vibrant community!",
  "property_created_at": "1753982388871",
  "property_scheduletour_blurb": "At Patriot Apts., nestled in vibrant El Paso, Texas, you'll find thoughtfully designed one, two, and three-bedroom floor plans to suit your lifestyle. Ready to see why our residents love calling us home? Schedule a tour today and hear their stories firsthand! Your new adventure awaits!",
  "property_thankyou_blurb": "Thank you for reaching out to Patriot Apts. in vibrant El Paso, Texas! We offer thoughtfully designed floor plans, including one, two, and three-bedroom options tailored to your lifestyle. Your journey to comfortable living starts here—stay tuned as we connect with you shortly to assist you further!",
  "property_virtualtours_blurb": "Welcome to Patriot Apts. in vibrant El Paso, Texas, where comfortable living meets modern design. Our spacious one, two, and three-bedroom floor plans cater to your lifestyle needs. Curious about your future home? Take a virtual tour today and envision your new life in our welcoming community!",
  "property_copyright": "2025 All Rights Reserved. Patriot Apts.",
  "property_seo_title_home": "Patriot Apts. |  Apartments in El Paso, Texas",
  "property_seo_description_home": "Unwind at Patriot Apartments in El Paso! Choose from 1-3 bedroom homes with amenities like a pool, fitness center, and picnic areas.",
  "property_seo_title_floorplans": "Floor Plans | El Paso, Texas Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal layout at Patriot Apts. in El Paso, TX! Choose from stylish one to three-bedroom floor plans tailored to your lifestyle. Browse today!",
  "property_seo_title_amenities": "Amenities | El Paso, Texas Apartments for Rent",
  "property_seo_description_amenities": "Join the Patriot Apts. community in El Paso! Enjoy a pool, fitness center, and pet play area. Discover your perfect home with fantastic amenities today!",
  "property_seo_title_gallery": "Gallery | Apartments in El Paso, Texas",
  "property_seo_description_gallery": "Step into a vibrant lifestyle at Patriot Apts. in El Paso! Envision your ideal space with top-notch amenities and stunning views. Picture yourself living here!",
  "property_seo_title_virtualtours": "Virtual Tours | Patriot Apts. Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Patriot Apts. in El Paso, TX. Enjoy spacious one to three-bedroom floor plans—take a virtual tour and envision your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | Patriot Apts. Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Patriot Apts. in El Paso! Explore our interactive map for available one, two, and three-bedroom apartments with top-notch amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in El Paso, Texas",
  "property_seo_description_neighborhood": "Uncover the best of El Paso living at Patriot Apts.! Dive into nearby gems and local favorites waiting just outside your door. Your next adventure starts here!",
  "property_seo_title_contact": "Contact Us | Patriot Apts.",
  "property_seo_description_contact": "Connect with Patriot Apts. in El Paso! Discover spacious one, two, and three-bedroom floor plans. Have questions? Our leasing team is here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in El Paso, Texas",
  "property_seo_description_faqs": "Find answers to your questions about Patriot Apts. in El Paso. From amenities to floor plans, get all the details you need to make it your new home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in El Paso, Texas",
  "property_seo_description_reviews": "Join the Patriot Apts. community in El Paso! Discover why our diverse amenities and friendly atmosphere make it the perfect home.",
  "property_seo_title_applynow": "Apply Now | Apartments in El Paso, Texas",
  "property_seo_description_applynow": "Upgrade your lifestyle at Patriot Apts. in El Paso! Enjoy spacious floor plans, a pool, fitness center, and vibrant community activities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Patriot Apts.",
  "property_seo_description_residentaccess": "Elevate your living experience at Patriot Apts. in El Paso. Log in to your resident portal for seamless rent payments, maintenance requests, and more!",
  "property_seo_title_referafriend": "Refer A Friend | Patriot Apts.",
  "property_seo_description_referafriend": "Refer a friend to Patriot Apts in El Paso! Great friends make great neighbors—share your love for our community and enjoy exclusive perks together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Patriot Apts.",
  "property_seo_description_scheduletour": "Experience the charm of Patriot Apts in El Paso! Schedule a tour and envision your new home amidst vibrant living and welcoming community vibes.",
  "property_seo_title_privacy": "Privacy Policy | Patriot Apts.",
  "property_seo_description_privacy": "At Patriot Apts in El Paso, we value your privacy. Learn how we protect your information and ensure a secure living experience. View our privacy policy today.",
  "property_seo_title_accessibility": "Website Accessibility | Patriot Apts.",
  "property_seo_description_accessibility": "At Patriot Apts in El Paso, we prioritize accessibility for all. Dive into our commitment to digital inclusion and ensure everyone feels at home here.",
  "property_seo_title_sitemap": "Sitemap | Patriot Apts.",
  "property_seo_description_sitemap": "Uncover the layout of Patriot Apts in El Paso, TX! Navigate your way to your dream home with our comprehensive sitemap. Your perfect apartment awaits!",
  "property_seo_title_thankyou": "Thank You | Patriot Apts.",
  "property_seo_description_thankyou": "Thank you for reaching out to Patriot Apts in El Paso! Our team is excited to assist you in finding your perfect home. Stay tuned for a prompt response!",
  "property_seo_title_pets": "Pet Policy | Apartments in El Paso, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865555090",
  "amenities": [
    {
      "id": "ec_b06281934623a19d3448fac8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396899",
      "title": "Spanish Speaking Staff",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17afcb9fc58e527a2dc0a986",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396901",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a955a4fb6ddc1daba4ee82a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396902",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_520d0b5d7a62f05930f81b1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396903",
      "title": "Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d053e7348bd660f318c3f3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396904",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e6bf4c6a01b736449aeee25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396905",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1738835047924acc49ba7ed4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396906",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_587af32fab67e5784d264fd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396907",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_933b93d413e58d2b6b9ab1f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396908",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7859b644fd09c2a46df9e139",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396909",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2db80efe5d2ecd40feae32ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396910",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d57ba1806a77ad2f0140b8ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396911",
      "title": "Onsite Pet Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83f014a3e262bc2fb338c0bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396912",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b688a5c14ecc57b4191e18cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396913",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c8653696fe6af2e27698801",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396914",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3cd121a5b1e76735bf73a19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396915",
      "title": "Nearby Neighborhood Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_59a5e57278952729df120baf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396916",
      "title": "Corporate Apartments Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c954e76b82ac5c3f1104f3dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396917",
      "title": "Ideal Location Near Fort Bliss",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01fa186e4e5fc63b023bc399",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396918",
      "title": "Easy Access to US-54, Loop 375 and Spur 601",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_89a837628fa8d36feb8f6086",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396919",
      "title": "Onsite Storage Units Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1603687b8e726b097ca7be16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396920",
      "title": "Short Term Leases Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0125867df28b9af69ffbc033",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "128042512",
      "title": "AT&T",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83aa6ded6afb7cfc21189ab3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127396921",
      "title": "Electronic Payments Accepted",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba0f09914ce1859e3f520e1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127398381",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17fc3862fa5e7e3875c5a4e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127398382",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a7fdbdacdf7fe40347b4ff7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127398383",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_46bac184ed862e8ebc4974c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127398384",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_11f5dd35120837b858633fc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127398385",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d0020eed254bb76ea5657ae8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127398386",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6981075b997c07bde1c8ceae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127398387",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_59e2ae4a38877d034708047a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127398388",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51965d63ae49b04ada719710",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127398389",
      "title": "Wheelchair Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_022d67e5f8e1b450295ec602",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127398390",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a0b9b20f0cf142459c12dfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127398391",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_658ddbd739934d8367c86872",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127398392",
      "title": "Roommate Friendly Floorplans Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d5f7b1498957fbd9199a2b38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127398393",
      "title": "Reliable Cell Reception",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ada6e2376d1277a0e8e65b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "yardi",
      "external_id": "127398394",
      "title": "Get connected to super fast internet powered by AT&T",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_202ae332-800a-47e6-b656-a27efc11e60e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-6076-71b8-90d6-c058ecbc2a1a.webp",
      "image_media": {
        "alt_text": "The Patriot Apartments monument sign and leasing office building with cars parked in front.",
        "public_id": "019d20af-6076-71b8-90d6-c058ecbc2a1a",
        "storage_key": "property/6767906449165618/019d20af-6076-71b8-90d6-c058ecbc2a1a.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Welcome to The Patriot Apartments, featuring a welcoming monument sign and a modern leasing office building, set amidst manicured landscaping and ample parking.",
      "link": "",
      "alt_text": "The Patriot Apartments monument sign and leasing office building with cars parked in front.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-2e73-7192-bc47-ca16f12c959c.webp"
    },
    {
      "id": "custom_b81b8e83-fd4b-4f90-bad2-c3134563d495",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-6063-775d-b38a-e7544f825498.webp",
      "image_media": {
        "alt_text": "Apartment community dog park with grass and play structures.",
        "public_id": "019d20af-6063-775d-b38a-e7544f825498",
        "storage_key": "property/6767906449165618/019d20af-6063-775d-b38a-e7544f825498.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, perfect for your furry friends to play and socialize in a safe and fenced environment.",
      "link": "",
      "alt_text": "Apartment community dog park with grass and play structures.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-2e73-7192-bc47-cd90f31f3e09.webp"
    },
    {
      "id": "custom_89ed17dd-a61e-484e-aa73-727d0799a044",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-606b-77dd-ada3-7f839e7e793b.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with multiple grills, picnic tables, and seating.",
        "public_id": "019d20af-606b-77dd-ada3-7f839e7e793b",
        "storage_key": "property/6767906449165618/019d20af-606b-77dd-ada3-7f839e7e793b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy our community's outdoor grilling stations, perfect for al fresco dining and gatherings with friends and neighbors.",
      "link": "",
      "alt_text": "Outdoor grilling area with multiple grills, picnic tables, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-2e35-7188-9ec3-e43a9d86c5e4.webp"
    },
    {
      "id": "custom_5ade1ed7-fdaf-4dc3-8078-1d04aad910ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-607a-71c9-aba6-0ac14cdd9de2.webp",
      "image_media": {
        "alt_text": "Playground area with slides and climbing structures under a blue canopy.",
        "public_id": "019d20af-607a-71c9-aba6-0ac14cdd9de2",
        "storage_key": "property/6767906449165618/019d20af-607a-71c9-aba6-0ac14cdd9de2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring slides and climbing structures perfect for children.",
      "link": "",
      "alt_text": "Playground area with slides and climbing structures under a blue canopy.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-2e6e-70bb-a046-02030a28877e.webp"
    },
    {
      "id": "custom_8562f290-b85d-4f60-949d-a367ed323ac9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-6c4e-72c9-b7a3-b592f1e93733.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019d20af-6c4e-72c9-b7a3-b592f1e93733",
        "storage_key": "property/6767906449165618/019d20af-6c4e-72c9-b7a3-b592f1e93733.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and a shaded pergola for relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-4288-712f-afb6-5bf0bb71f099.webp"
    },
    {
      "id": "custom_db38d3cd-227e-4a42-9758-38546800a1d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-6bbd-7688-be66-9e5d5cd38241.webp",
      "image_media": {
        "alt_text": "Apartment complex with a fenced dog park and picnic area.",
        "public_id": "019d20af-6bbd-7688-be66-9e5d5cd38241",
        "storage_key": "property/6767906449165618/019d20af-6bbd-7688-be66-9e5d5cd38241.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park and outdoor picnic area, perfect for relaxing and socializing with neighbors.",
      "link": "",
      "alt_text": "Apartment complex with a fenced dog park and picnic area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-466d-7136-b4c3-5200d780f390.webp"
    },
    {
      "id": "custom_48e8a479-b086-4e03-8def-96841e3662ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-6c3e-77da-af40-aa4907442864.webp",
      "image_media": {
        "alt_text": "Community swimming pool with lounge chairs and trees.",
        "public_id": "019d20af-6c3e-77da-af40-aa4907442864",
        "storage_key": "property/6767906449165618/019d20af-6c3e-77da-af40-aa4907442864.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling community swimming pool, surrounded by lush trees and comfortable lounge chairs for relaxation.",
      "link": "",
      "alt_text": "Community swimming pool with lounge chairs and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-486b-714c-9ab9-0a31542be715.webp"
    },
    {
      "id": "custom_25311923-dd9c-4c5e-ae3a-26b0397c4346",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-6e9c-7559-8239-772e32d9ced7.webp",
      "image_media": {
        "alt_text": "Community Resource Center building exterior with double blue doors and signage.",
        "public_id": "019d20af-6e9c-7559-8239-772e32d9ced7",
        "storage_key": "property/6767906449165618/019d20af-6e9c-7559-8239-772e32d9ced7.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Welcome to the Community Resource Center, a central hub for residents. This building features a welcoming exterior with double blue doors and clear signage.",
      "link": "",
      "alt_text": "Community Resource Center building exterior with double blue doors and signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-3326-7027-acb6-a92f9ee186b1.webp"
    },
    {
      "id": "custom_997a8cca-eb7a-4379-8f5e-a078b5aa2021",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-75d4-7697-92ea-ded07db51aa0.webp",
      "image_media": {
        "alt_text": "Exterior view of a two-story apartment building with a central walkway leading to the entrance.",
        "public_id": "019d20af-75d4-7697-92ea-ded07db51aa0",
        "storage_key": "property/6767906449165618/019d20af-75d4-7697-92ea-ded07db51aa0.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "The exterior of a two-story apartment complex, showcasing its building facade and common area walkway.",
      "link": "",
      "alt_text": "Exterior view of a two-story apartment building with a central walkway leading to the entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-32db-757b-a1f4-6b501a4b1d33.webp"
    },
    {
      "id": "custom_9a4f0bfc-42c7-4643-a363-7f88d8ab9182",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-7779-7159-957f-3c05d2b6db26.webp",
      "image_media": {
        "alt_text": "Business center with computers, printers, and a water cooler.",
        "public_id": "019d20af-7779-7159-957f-3c05d2b6db26",
        "storage_key": "property/6767906449165618/019d20af-7779-7159-957f-3c05d2b6db26.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Stay connected in our business center, equipped with computers and printers for your convenience.",
      "link": "",
      "alt_text": "Business center with computers, printers, and a water cooler.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-2e6e-70bb-a046-0669fd7d6087.webp"
    },
    {
      "id": "custom_28df5200-553f-4577-9c31-71c0b8adeeec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-78fa-764b-8816-2fecbb2b70cb.webp",
      "image_media": {
        "alt_text": "Exterior walkway with stairs leading to apartments",
        "public_id": "019d20af-78fa-764b-8816-2fecbb2b70cb",
        "storage_key": "property/6767906449165618/019d20af-78fa-764b-8816-2fecbb2b70cb.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Community",
      "description": "View down a covered walkway with stairs leading to apartment entrances. This outdoor hallway offers access to units on multiple levels.",
      "link": "",
      "alt_text": "Exterior walkway with stairs leading to apartments",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-3fec-764f-8ca9-bf28631210fd.webp"
    },
    {
      "id": "custom_0a064c48-16ea-4f1d-b144-5d129d8ec082",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-7a2c-77ce-9619-b93df5d2b6c6.webp",
      "image_media": {
        "alt_text": "Community lounge with seating areas and tables.",
        "public_id": "019d20af-7a2c-77ce-9619-b93df5d2b6c6",
        "storage_key": "property/6767906449165618/019d20af-7a2c-77ce-9619-b93df5d2b6c6.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Gather with neighbors in the comfortable community lounge, featuring ample seating and tables for socializing.",
      "link": "",
      "alt_text": "Community lounge with seating areas and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-4c03-76e4-bf13-37e1dba2b707.webp"
    },
    {
      "id": "custom_fa8a2a7e-b47f-492e-8264-0f2288089f18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-813d-71d0-8633-10c660b8b5c9.webp",
      "image_media": {
        "alt_text": "Leasing office with desks, chairs, and windows overlooking the grounds.",
        "public_id": "019d20af-813d-71d0-8633-10c660b8b5c9",
        "storage_key": "property/6767906449165618/019d20af-813d-71d0-8633-10c660b8b5c9.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Welcome to our leasing office, where our friendly staff is ready to assist you with all your needs.",
      "link": "",
      "alt_text": "Leasing office with desks, chairs, and windows overlooking the grounds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-4bca-77aa-ab87-8c4d2bba833c.webp"
    },
    {
      "id": "custom_fe891a05-ca0f-47e2-a71e-03b951bf6b44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-8233-72f5-81d4-24527b1e0c29.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, free weights, and weight machines.",
        "public_id": "019d20af-8233-72f5-81d4-24527b1e0c29",
        "storage_key": "property/6767906449165618/019d20af-8233-72f5-81d4-24527b1e0c29.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Our fully equipped fitness center offers a variety of cardio machines, free weights, and strength training equipment for your workout needs.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, free weights, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-4c91-764c-8fe7-84ebf7b1c39c.webp"
    },
    {
      "id": "custom_c1b61d97-d2b4-4608-99f1-c93df7f833de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-825c-776c-958e-0f892314e4f7.webp",
      "image_media": {
        "alt_text": "Community lounge with sofas, armchairs, coffee table, and dining tables.",
        "public_id": "019d20af-825c-776c-958e-0f892314e4f7",
        "storage_key": "property/6767906449165618/019d20af-825c-776c-958e-0f892314e4f7.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax and socialize in our comfortable community lounge, featuring ample seating and dining areas.",
      "link": "",
      "alt_text": "Community lounge with sofas, armchairs, coffee table, and dining tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-54e7-7333-8fcd-0588e3ee5983.webp"
    },
    {
      "id": "custom_981ef9fe-6dc0-4e5a-b94f-7d7af351bcf8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-8918-7379-8691-72a05d8242d4.webp",
      "image_media": {
        "alt_text": "Clubhouse common area with tables and chairs, including a bar area.",
        "public_id": "019d20af-8918-7379-8691-72a05d8242d4",
        "storage_key": "property/6767906449165618/019d20af-8918-7379-8691-72a05d8242d4.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in our spacious clubhouse, perfect for events or casual get-togethers.",
      "link": "",
      "alt_text": "Clubhouse common area with tables and chairs, including a bar area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-5e8c-778f-babb-1b93484cadc5.webp"
    },
    {
      "id": "custom_45e3a92f-92c0-4fc7-8ce0-dea07ad9ca23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-8a9d-71df-bb70-ebbf2d48a777.webp",
      "image_media": {
        "alt_text": "Cozy living room with a fireplace and a sofa.",
        "public_id": "019d20af-8a9d-71df-bb70-ebbf2d48a777",
        "storage_key": "property/6767906449165618/019d20af-8a9d-71df-bb70-ebbf2d48a777.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax in the inviting living area, featuring a warm fireplace and comfortable seating.",
      "link": "",
      "alt_text": "Cozy living room with a fireplace and a sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-648a-73f9-820e-ebed02fd59b3.webp"
    },
    {
      "id": "custom_b6510f8a-62e4-44b0-ab5b-1f6715307779",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-8c56-774d-8196-796607513ec7.webp",
      "image_media": {
        "alt_text": "Closet with water heater and laundry hookups.",
        "public_id": "019d20af-8c56-774d-8196-796607513ec7",
        "storage_key": "property/6767906449165618/019d20af-8c56-774d-8196-796607513ec7.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry closet with hookups and a water heater.",
      "link": "",
      "alt_text": "Closet with water heater and laundry hookups.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-2da1-74ac-a103-c88ba11df9c1.webp"
    },
    {
      "id": "custom_b34e19eb-83da-4289-b421-1fd40e2cc4a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-915d-74f8-882f-3a36784f4ff2.webp",
      "image_media": {
        "alt_text": "Comfortable bedroom with a queen-size bed, patterned comforter, and a nightstand with a lamp.",
        "public_id": "019d20af-915d-74f8-882f-3a36784f4ff2",
        "storage_key": "property/6767906449165618/019d20af-915d-74f8-882f-3a36784f4ff2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Relax in this cozy bedroom, featuring a comfortable queen-size bed and ample natural light from the window.",
      "link": "",
      "alt_text": "Comfortable bedroom with a queen-size bed, patterned comforter, and a nightstand with a lamp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-2e95-7160-a3f8-0a2b9ca2d98b.webp"
    },
    {
      "id": "custom_3c5796de-226d-4863-8122-32f20ae5d804",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-9356-725a-84e5-c2ecce812ddc.webp",
      "image_media": {
        "alt_text": "Walk-in closet with built-in shelving and hanging rod.",
        "public_id": "019d20af-9356-725a-84e5-c2ecce812ddc",
        "storage_key": "property/6767906449165618/019d20af-9356-725a-84e5-c2ecce812ddc.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and a hanging rod for organized storage.",
      "link": "",
      "alt_text": "Walk-in closet with built-in shelving and hanging rod.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-3357-70ea-925c-dad912e6c6aa.webp"
    },
    {
      "id": "custom_51f46ba1-65fa-4efb-9b2d-2cb013d6d9f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-944b-75b9-ad45-f73503d51ee2.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, patterned comforter, and decorative pillows.",
        "public_id": "019d20af-944b-75b9-ad45-f73503d51ee2",
        "storage_key": "property/6767906449165618/019d20af-944b-75b9-ad45-f73503d51ee2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with decorative pillows and a colorful comforter, perfect for a restful night's sleep.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, patterned comforter, and decorative pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-3fcf-7768-900c-96d878c7cf73.webp"
    },
    {
      "id": "custom_b37684c1-1914-4726-8931-da571407117b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-99b9-7739-b79d-581f451f4a0d.webp",
      "image_media": {
        "alt_text": "Closet with shelf and hanging rod",
        "public_id": "019d20af-99b9-7739-b79d-581f451f4a0d",
        "storage_key": "property/6767906449165618/019d20af-99b9-7739-b79d-581f451f4a0d.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Ample closet space with a shelf and hanging rod for storage.",
      "link": "",
      "alt_text": "Closet with shelf and hanging rod",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-4030-7016-be1d-4a1b2edd70ba.webp"
    },
    {
      "id": "custom_feace592-2d0e-41da-b6c3-d5f287b4202b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-9b21-701b-bf23-05ebb3586765.webp",
      "image_media": {
        "alt_text": "Kitchen area with a small dining table and chairs, a refrigerator, and a laundry closet.",
        "public_id": "019d20af-9b21-701b-bf23-05ebb3586765",
        "storage_key": "property/6767906449165618/019d20af-9b21-701b-bf23-05ebb3586765.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A compact kitchen space featuring a dining table for two, a refrigerator, and a convenient laundry closet with a water heater.",
      "link": "",
      "alt_text": "Kitchen area with a small dining table and chairs, a refrigerator, and a laundry closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-46a6-73bb-b727-c4a8cb64dc7a.webp"
    },
    {
      "id": "custom_53c54a3d-0fa7-4eb8-aa23-003040c08354",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-9e15-74ea-a7b4-38f861995d5c.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, armchair, and a bookshelf near a window.",
        "public_id": "019d20af-9e15-74ea-a7b4-38f861995d5c",
        "storage_key": "property/6767906449165618/019d20af-9e15-74ea-a7b4-38f861995d5c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Comfortable and stylish living room featuring a plush sofa, decorative coffee table, cozy armchair, and a well-organized bookshelf, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, armchair, and a bookshelf near a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-5298-7348-910b-85cd2d9999c1.webp"
    },
    {
      "id": "custom_f50aa77b-603a-4959-8fbc-3884233e85f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-9f76-73bd-a8bf-3ccb8b43b9ab.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and window.",
        "public_id": "019d20af-9f76-73bd-a8bf-3ccb8b43b9ab",
        "storage_key": "property/6767906449165618/019d20af-9f76-73bd-a8bf-3ccb8b43b9ab.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, accent armchair, and a unique coffee table, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, armchair, coffee table, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-59a4-7703-beb8-100520a237ab.webp"
    },
    {
      "id": "custom_dd8d52cc-3ea9-4a17-a2a8-9cef86881534",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-a830-7363-87fc-5f101bdde43c.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, stove, sink, and dishwasher.",
        "public_id": "019d20af-a830-7363-87fc-5f101bdde43c",
        "storage_key": "property/6767906449165618/019d20af-a830-7363-87fc-5f101bdde43c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring white cabinetry, a stove, sink, and dishwasher. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, stove, sink, and dishwasher.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-59cb-70bf-a2cb-6ea0334dc0db.webp"
    },
    {
      "id": "custom_57453e21-2690-4c27-8152-4d1a34c1659f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-a88b-70fe-83b5-f4669903f77f.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with double sinks, large mirror, and organized storage.",
        "public_id": "019d20af-a88b-70fe-83b5-f4669903f77f",
        "storage_key": "property/6767906449165618/019d20af-a88b-70fe-83b5-f4669903f77f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A clean and organized bathroom featuring a spacious vanity with ample counter space, a large mirror, and decorative touches.",
      "link": "",
      "alt_text": "Bathroom vanity with double sinks, large mirror, and organized storage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-61fc-7792-b521-00da62dfb3f2.webp"
    },
    {
      "id": "custom_408e0543-fbe7-4dcc-af9e-b4e249d97d42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-a89b-701c-b1cc-ed9a3995e278.webp",
      "image_media": {
        "alt_text": "Kitchen and hallway",
        "public_id": "019d20af-a89b-701c-b1cc-ed9a3995e278",
        "storage_key": "property/6767906449165618/019d20af-a89b-701c-b1cc-ed9a3995e278.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "View of the apartment's kitchen and hallway, featuring white appliances, cabinetry, and wood-look flooring.",
      "link": "",
      "alt_text": "Kitchen and hallway",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-6207-77c0-b887-ff3b8f0a730e.webp"
    },
    {
      "id": "custom_a01fdaaf-1a10-4364-925e-60cab63378f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-a9bb-778a-a9c8-f4f9e88db864.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel appliances including a refrigerator, stove, microwave, and dishwasher.",
        "public_id": "019d20af-a9bb-778a-a9c8-f4f9e88db864",
        "storage_key": "property/6767906449165618/019d20af-a9bb-778a-a9c8-f4f9e88db864.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample white cabinetry, a double sink, and modern stainless steel appliances.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, stainless steel appliances including a refrigerator, stove, microwave, and dishwasher.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-610c-720f-b3e4-1a15a53b40c0.webp"
    },
    {
      "id": "custom_92790827-30d9-4772-91ae-9e25ccb4fdea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d20af-b18e-70eb-bdef-4833eaea307e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a toilet, sink, and shower.",
        "public_id": "019d20af-b18e-70eb-bdef-4833eaea307e",
        "storage_key": "property/6767906449165618/019d20af-b18e-70eb-bdef-4833eaea307e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Freshen up in this spacious bathroom featuring a soaking tub, vanity, and ample storage. Modern finishes add a touch of style to your daily routine.",
      "link": "",
      "alt_text": "Modern bathroom with a toilet, sink, and shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-6289-7227-a753-b4474d272e69.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_f232967f-6913-4ca2-82ac-ad53dcf45f4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "10721 Gateway S Blvd, El Paso, TX 79924, USA",
      "poi_short_description": "Chain known for chicken sandwiches, nuggets and waffle fries as well as salads and breakfast dishes.",
      "poi_long_description": "People say this fast food restaurant offers delicious salads and a great breakfast menu, including burritos and chicken biscuits. They highlight the fresh ingredients, quick service, and friendly staff. They also like the efficient drive-thru and the coupons offered by the management.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-d576-7409-bc27-622f9575cbf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-d576-7409-bc27-622f9575cbf2",
        "storage_key": "property/6767906449165618/019cfb44-d576-7409-bc27-622f9575cbf2.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/tx/north-hills-crossing?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=3930066830588912966&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "31.9239669",
      "poi_longitude": "-106.4399772",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-821-0624",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9ec-720e-b9a9-6f717cf43599",
        "storage_key": "property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo6Ls7PVT54YRRiXMxPVmijY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_94d5994f-f065-48f6-91d9-766e4a149d43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Tortilleria Crystal",
      "poi_type": "Restaurants",
      "poi_address": "10310 McCombs St, El Paso, TX 79924, USA",
      "poi_short_description": "Casual Mexican restaurant serving traditional eats such as menudo, pozole, tamales, and burritos.",
      "poi_long_description": "People say this Mexican restaurant serves delicious barbacoa, chicharrones, menudo, and tamales. They highlight the generous portions, reasonable prices, and authentic Mexican food. They also like the fast service and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-d46f-718c-b10b-1abf336f6980.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-d46f-718c-b10b-1abf336f6980",
        "storage_key": "property/6767906449165618/019cfb44-d46f-718c-b10b-1abf336f6980.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tortilleriacrystal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12651483200580690823&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tortilleria-crystal",
      "poi_latitude": "31.910679",
      "poi_longitude": "-106.406518",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-740-1363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9ec-720e-b9a9-6f717cf43599",
        "storage_key": "property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYdpICthT54YRhyNvxPAYk68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_8f3336c4-d589-4f1a-adae-4527ccc13d86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1724 Marshall Rd, Fort Bliss, TX 79906, USA",
      "poi_short_description": "Chain restaurant known for its chicken fingers and other fast food fare served with a Southern flair.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, toast, and fries. They highlight the fast service, friendly staff, and the addictive Cane's Sauce. They also like the simple menu and the consistently hot and fresh food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-d5c2-74c7-9962-e37581b61009.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-d5c2-74c7-9962-e37581b61009",
        "storage_key": "property/6767906449165618/019cfb44-d5c2-74c7-9962-e37581b61009.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/tx/fort-bliss/1724-marshall-road",
      "poi_directions_map_url": "https://maps.google.com/?cid=10561730785186627053&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "31.8198594",
      "poi_longitude": "-106.4305392",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-300-1088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9ec-720e-b9a9-6f717cf43599",
        "storage_key": "property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7UvS40dR54YR7T1b0DDOkpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_71c912bf-3bcf-4cbf-a3c9-d2f905d98800",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "The Shack Wings & Brews",
      "poi_type": "Restaurants",
      "poi_address": "4726 Woodrow Bean Transmountain, El Paso, TX 79924, USA",
      "poi_short_description": "Nachos, fried pickles, and other bar bites served in a casual space with a patio and happy-hour specials.",
      "poi_long_description": "People say this restaurant serves delicious wings, burgers, and salads. They highlight the fresh food, good variety of flavors, and generous portions. They also like the lively atmosphere, perfect for watching sports, and the attentive, friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-d48d-72b1-bdca-a96c1008bf9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-d48d-72b1-bdca-a96c1008bf9d",
        "storage_key": "property/6767906449165618/019cfb44-d48d-72b1-bdca-a96c1008bf9d.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://www.theshackwings.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10310762310929778218&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-shack-wings--brews",
      "poi_latitude": "31.8980077",
      "poi_longitude": "-106.4336998",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-955-9464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9ec-720e-b9a9-6f717cf43599",
        "storage_key": "property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrzXB6whR54YRKoZ0arEvF48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_cf03bb30-c2e0-49c2-aece-3ac2caf9bc20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Tommy's Korean Express",
      "poi_type": "Restaurants",
      "poi_address": "9477 Dyer St, El Paso, TX 79924, USA",
      "poi_short_description": "Informal restaurant featuring Korean staples including bulgogi, bibimbap and fried rice.",
      "poi_long_description": "People say this restaurant offers delicious bibimbap bowls, ramen, and a variety of Korean snacks, with fresh, homemade ingredients and generous portions. They highlight the fun, interactive DIY ramen bar, the clean and modern atmosphere, and the welcoming vibe. They also like the friendly, helpful, and patient staff, and the fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-d45f-7766-b63d-a36553b3cc9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-d45f-7766-b63d-a36553b3cc9f",
        "storage_key": "property/6767906449165618/019cfb44-d45f-7766-b63d-a36553b3cc9f.webp",
        "width": 962,
        "height": 1280
      },
      "poi_business_url": "http://tommyskoreanexpress.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14537189276526066566&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tommys-korean-express",
      "poi_latitude": "31.8802817",
      "poi_longitude": "-106.4216084",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-261-7952",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9ec-720e-b9a9-6f717cf43599",
        "storage_key": "property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWxB6w-9R54YRhjv0K6B4vsk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ed505704-a0c0-4cd8-8da1-3a4f8763f5b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Fort Bliss - Exchange",
      "poi_type": "Shopping & Retail",
      "poi_address": "1611 Haan Rd, Fort Bliss, TX 79906, USA",
      "poi_short_description": "Shopping mall at Freedom Crossing at Fort Bliss with a food court and tax-free bonus savings for military members and veterans.",
      "poi_long_description": "People say this shopping center offers a huge selection of products and services, including a food court with fantastic choices like New York-style pizza. They highlight the clean and well-organized layout, and the friendly and helpful staff. They also like the quick and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-d61a-770a-986f-27ea7f7f17b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-d61a-770a-986f-27ea7f7f17b2",
        "storage_key": "property/6767906449165618/019cfb44-d61a-770a-986f-27ea7f7f17b2.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.shopmyexchange.com/exchange-stores/United%20States/TX/Ft.%20Bliss/Ft-Bliss--1011801",
      "poi_directions_map_url": "https://maps.google.com/?cid=10221724360285077533&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-bliss---exchange",
      "poi_latitude": "31.8180883",
      "poi_longitude": "-106.4295632",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-562-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9bd-73e8-8a95-264f05fc9934.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9bd-73e8-8a95-264f05fc9934",
        "storage_key": "property/6767906449165618/019cfb44-e9bd-73e8-8a95-264f05fc9934.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ83LPBZ9Z54YRHcC_Dibc2o0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_bc2d65e6-f91d-4f36-aa06-c21e936d8c9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "4531 Woodrow Bean Transmountain, El Paso, TX 79924, USA",
      "poi_short_description": "Home-improvement chain supplying appliances, paint, and other hardware items, plus installation services.",
      "poi_long_description": "People say this home improvement store offers a wide variety of plants at reasonable prices, and they also highlight the friendly and helpful staff who go the extra mile to assist customers. They like that the store is well-stocked and has everything they need, including replacement parts and glass cutting services.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-d43b-738c-87fc-57616caada57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-d43b-738c-87fc-57616caada57",
        "storage_key": "property/6767906449165618/019cfb44-d43b-738c-87fc-57616caada57.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/TX-El-Paso/1137?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1137-_-na-_-0-_-0&y_source=1_MTE4NDM4OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7837371491399021930&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "31.900837",
      "poi_longitude": "-106.4387257",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-755-9155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9bd-73e8-8a95-264f05fc9934.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9bd-73e8-8a95-264f05fc9934",
        "storage_key": "property/6767906449165618/019cfb44-e9bd-73e8-8a95-264f05fc9934.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3_8aFlNR54YRarWc5djvw2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_6e8e3f01-8c80-41e7-814c-40e875c87fb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Commissary",
      "poi_type": "Shopping & Retail",
      "poi_address": "1620 Marshall Rd, Fort Bliss, TX 79916, USA",
      "poi_short_description": "Chain grocery store supplying produce, meat, and other standard groceries at Freedom Crossing at Fort Bliss.",
      "poi_long_description": "Straightforward outpost offering meat, produce, pantry items & other supermarket fare for veterans.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-d481-7761-8c52-ef33c6fa23e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-d481-7761-8c52-ef33c6fa23e9",
        "storage_key": "property/6767906449165618/019cfb44-d481-7761-8c52-ef33c6fa23e9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://shop.commissaries.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7763765656611879353&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "commissary",
      "poi_latitude": "31.8150997",
      "poi_longitude": "-106.4271685",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-568-6688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9b2-723d-a78f-b7fef71df40a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9b2-723d-a78f-b7fef71df40a",
        "storage_key": "property/6767906449165618/019cfb44-e9b2-723d-a78f-b7fef71df40a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB0F56wha54YRuXm6Abtvvms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4ed5d7d9-7722-42bb-81d4-e85bfb291aed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Arirang Korean Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9728 Dyer St # F, El Paso, TX 79924, USA",
      "poi_short_description": "Supermarket specializing in imported Asian foods, including produce and snacks, plus in-house kimchi and kimbap.",
      "poi_long_description": "People say this Korean grocery store offers a wide variety of Korean products, including sauces, seasonings, frozen seafood, and seasonal items. They highlight the fair prices, clean store, and well-organized layout. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-d480-73ae-a3f9-f83c47fde479.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-d480-73ae-a3f9-f83c47fde479",
        "storage_key": "property/6767906449165618/019cfb44-d480-73ae-a3f9-f83c47fde479.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3756594790934177334&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arirang-korean-market",
      "poi_latitude": "31.8898382",
      "poi_longitude": "-106.4141817",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-751-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9b2-723d-a78f-b7fef71df40a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9b2-723d-a78f-b7fef71df40a",
        "storage_key": "property/6767906449165618/019cfb44-e9b2-723d-a78f-b7fef71df40a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs-MR_mpR54YRNua2Hg8bIjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_b0279c54-f3cf-4ebb-b87b-f0bf1853c440",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Freedom Crossing at Fort Bliss",
      "poi_type": "Shopping & Retail",
      "poi_address": "1611 Haan Rd, Fort Bliss, TX 79906, USA",
      "poi_short_description": "Open-air shopping center on an Army base featuring an expanded exchange, eateries, and more.",
      "poi_long_description": "People say this shopping center offers a wide variety of shops, restaurants, and entertainment options, including a movie theater, spa, and splash pad. They highlight the clean and well-maintained facilities, and the convenient location on post. They also like the fun, free events hosted throughout the year.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-d65b-75d8-926b-ae8124132a2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-d65b-75d8-926b-ae8124132a2d",
        "storage_key": "property/6767906449165618/019cfb44-d65b-75d8-926b-ae8124132a2d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://freedomcrossingatfortbliss.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15335932499406216917&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "freedom-crossing-at-fort-bliss",
      "poi_latitude": "31.8175",
      "poi_longitude": "-106.4291667",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-503-2896",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9bd-73e8-8a95-264f05fc9934.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9bd-73e8-8a95-264f05fc9934",
        "storage_key": "property/6767906449165618/019cfb44-e9bd-73e8-8a95-264f05fc9934.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJU8dE3gda54YR1d553lot1NQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_ae2319e7-5675-4490-9dd2-c677bf6a4b1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "El Paso Community College - Transmountain Campus - EPCC TM",
      "poi_type": "Education",
      "poi_address": "9570 Gateway N Blvd, El Paso, TX 79924, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-d9b1-72de-8106-396fb0ff072d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-d9b1-72de-8106-396fb0ff072d",
        "storage_key": "property/6767906449165618/019cfb44-d9b1-72de-8106-396fb0ff072d.webp",
        "width": 1280,
        "height": 623
      },
      "poi_business_url": "http://epcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13126049052638451289&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-community-college---transmountain-campus---epcc-tm",
      "poi_latitude": "31.886595",
      "poi_longitude": "-106.438272",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-831-3722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9b1-7546-bda9-b16ca0c0cb90",
        "storage_key": "property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcw1IrUtR54YRWRbejhEYKbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9ee516fa-e9ad-4a32-9d09-14d17fd07f95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "El Paso Public Library Richard Burges Branch",
      "poi_type": "Education",
      "poi_address": "9600 Dyer St C, El Paso, TX 79924, USA",
      "poi_short_description": "Spacious library featuring a selection of books for kids, plus a Lego area and a study room.",
      "poi_long_description": "People say this public library has helpful staff who are friendly and polite. They also highlight the library as a great place to catch up on work and school.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-da34-70b9-9046-af776c35163b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-da34-70b9-9046-af776c35163b",
        "storage_key": "property/6767906449165618/019cfb44-da34-70b9-9046-af776c35163b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.elpasolibrary.org/locations/richard-burges/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16805168051985469060&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-public-library-richard-burges-branch",
      "poi_latitude": "31.8866548",
      "poi_longitude": "-106.4156425",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-212-0317",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9b1-7546-bda9-b16ca0c0cb90",
        "storage_key": "property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCdE6tWpR54YRhE5WQU7zN-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_28aa0a6a-d887-47be-b7ec-2192b022c195",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Parkland Pre K",
      "poi_type": "Education",
      "poi_address": "9790 Pickerel Dr, El Paso, TX 79924, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-d950-700f-8e1a-b6d5244cb73f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-d950-700f-8e1a-b6d5244cb73f",
        "storage_key": "property/6767906449165618/019cfb44-d950-700f-8e1a-b6d5244cb73f.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://parklandprek.yisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3904396599691041893&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "parkland-pre-k",
      "poi_latitude": "31.8912777",
      "poi_longitude": "-106.402678",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-435-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9b1-7546-bda9-b16ca0c0cb90",
        "storage_key": "property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbQQZ5npR54YRZdzTYgU0LzY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_218537a6-c434-4e9a-bf6b-78ef1d970cf2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Fort Bliss Museum",
      "poi_type": "Entertainment",
      "poi_address": "1735 Marshall Rd, Fort Bliss, TX 79906, USA",
      "poi_short_description": "Large, free museum with tanks, trucks and military displays, uniforms and artifacts documenting the history of Fort Bliss and the First Armored Division.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-d8f0-7457-a136-bca5e6393766.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-d8f0-7457-a136-bca5e6393766",
        "storage_key": "property/6767906449165618/019cfb44-d8f0-7457-a136-bca5e6393766.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://home.army.mil/bliss/index.php/my-fort/all-services/fort-bliss-and-old-ironsides-museu",
      "poi_directions_map_url": "https://maps.google.com/?cid=7293167302618848693&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-bliss-museum",
      "poi_latitude": "31.8218243",
      "poi_longitude": "-106.4285014",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-568-5412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c6-70cb-a25b-2cdafc68684a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c6-70cb-a25b-2cdafc68684a",
        "storage_key": "property/6767906449165618/019cfb44-e9c6-70cb-a25b-2cdafc68684a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QxGxefF4IYRtR0XWAWJNmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_07dd364b-c532-4161-9d4c-65f1dc2e2620",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Camp Cohen Water Park",
      "poi_type": "Entertainment",
      "poi_address": "9700 Gateway N Blvd, El Paso, TX 79924, USA",
      "poi_short_description": "Seasonal water park featuring pools, slides, and a lazy river.",
      "poi_long_description": "People say this water park offers a lazy river, big water slides, and pools with mountain views. They also highlight the attentive staff, clean facilities, and safe environment with plenty of lifeguards.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-d9f5-7330-8a0e-05a7d63db37e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-d9f5-7330-8a0e-05a7d63db37e",
        "storage_key": "property/6767906449165618/019cfb44-d9f5-7330-8a0e-05a7d63db37e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://epwaterparks.com/camp-cohen",
      "poi_directions_map_url": "https://maps.google.com/?cid=14832279656457082066&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "camp-cohen-water-park",
      "poi_latitude": "31.891998",
      "poi_longitude": "-106.4364932",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-541-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Q7X4BVR54YR0pRgRMPX1s0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_fbe9e43c-7043-47a1-b380-d7072e83c83e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "El Paso Tin Mines",
      "poi_type": "Entertainment",
      "poi_address": "North Franklin Mountain Trail, El Paso, TX 79934, USA",
      "poi_short_description": "Hiking trail with loose rocks and no shade through a historical landmark with tunnels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-da65-722a-bd55-eb6bf92d70a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-da65-722a-bd55-eb6bf92d70a2",
        "storage_key": "property/6767906449165618/019cfb44-da65-722a-bd55-eb6bf92d70a2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://tpwd.texas.gov/state-parks/franklin-mountains/park_history",
      "poi_directions_map_url": "https://maps.google.com/?cid=3226073351066364428&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-tin-mines",
      "poi_latitude": "31.9358721",
      "poi_longitude": "-106.4881299",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 915-541-4145",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfWc91KxV54YRDCqqzZ5QxSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_ee294ddc-38b1-4331-86fa-fa27b30d346e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "El Paso Museum of Archaeology",
      "poi_type": "Entertainment",
      "poi_address": "4301 Woodrow Bean Transmountain Dr, El Paso, TX 79924, USA",
      "poi_short_description": "Informative, family-friendly history spot featuring artifacts, dioramas, sculptures and pottery.",
      "poi_long_description": "Visitors say this museum offers a wealth of information about the history and culture of El Paso, as well as the indigenous history of the area, and features a lovely nature trail in the shadow of the Franklin Mountains. They also highlight the museum's free admission, family-friendly atmosphere, and well-done events with kind vendors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-da85-76bf-b66a-575fd95631cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-da85-76bf-b66a-575fd95631cd",
        "storage_key": "property/6767906449165618/019cfb44-da85-76bf-b66a-575fd95631cd.webp",
        "width": 1200,
        "height": 650
      },
      "poi_business_url": "http://epmarch.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8265411461810075806&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-museum-of-archaeology",
      "poi_latitude": "31.9036702",
      "poi_longitude": "-106.4490514",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-212-0421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c6-70cb-a25b-2cdafc68684a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c6-70cb-a25b-2cdafc68684a",
        "storage_key": "property/6767906449165618/019cfb44-e9c6-70cb-a25b-2cdafc68684a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJCUoxMmZR54YRnriht-6jtHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a50af21a-f2ec-4fbc-b82e-c043a5579017",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "National Border Patrol Museum",
      "poi_type": "Entertainment",
      "poi_address": "4315 Woodrow Bean Transmountain Dr, El Paso, TX 79924, USA",
      "poi_short_description": "Free museum showcasing the vehicles and uniforms used to patrol the United States’ borders.",
      "poi_long_description": "Visitors say this museum offers a fascinating look into the history of the Border Patrol, with exhibits on topics like illegal immigration, prohibition, and modern-day challenges. They also highlight the friendly and knowledgeable staff, the kid-friendly displays of vehicles and equipment, and the opportunity to learn about the sacrifices made by Border Patrol agents.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-daed-7219-9012-7ec31073b9a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-daed-7219-9012-7ec31073b9a0",
        "storage_key": "property/6767906449165618/019cfb44-daed-7219-9012-7ec31073b9a0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.borderpatrolmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10073419789093694472&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "national-border-patrol-museum",
      "poi_latitude": "31.9030697",
      "poi_longitude": "-106.4486364",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-759-6060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c6-70cb-a25b-2cdafc68684a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c6-70cb-a25b-2cdafc68684a",
        "storage_key": "property/6767906449165618/019cfb44-e9c6-70cb-a25b-2cdafc68684a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJCUoxMmZR54YRCOxRSu35y4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e24d5dc0-58d7-45d5-862c-17a9a395509a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Joshua W. Soto Physical Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "20751 Constitution Ave, Fort Bliss, TX 79918, USA",
      "poi_short_description": "Gym featuring a basketball court and clean showers and equipment, as well as a track.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including cardio machines, weightlifting equipment, and basketball courts, as well as an indoor track and sauna. They highlight the gym's spacious layout, clean facilities, and the availability of a smoothie store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-dbca-75fc-9524-045abaf668e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-dbca-75fc-9524-045abaf668e0",
        "storage_key": "property/6767906449165618/019cfb44-dbca-75fc-9524-045abaf668e0.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://bliss.armymwr.com/programs/joshua-w-soto-physical-fitness-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9843518981860297653&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "joshua-w-soto-physical-fitness-center",
      "poi_latitude": "31.849859",
      "poi_longitude": "-106.3546891",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 915-744-5788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-dhbjxhQ54YRtQuZXVw0m4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_81f776c7-16ec-42e6-a08d-8dc791a20467",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Crunch Fitness - El Paso Dyer",
      "poi_type": "Health and Wellness",
      "poi_address": "9155 Dyer St, El Paso, TX 79924, USA",
      "poi_short_description": "Clean, bright, spacious chain gym, featuring treadmills, elliptical trainers, bike trainers and weight machines, plus classes and personal training.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, cardio machines, and a sauna, and the staff is friendly and welcoming.\n\nOther reviews mention the gym can be crowded and the membership pricing can be confusing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-db95-770d-9576-5f44ebb944f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-db95-770d-9576-5f44ebb944f8",
        "storage_key": "property/6767906449165618/019cfb44-db95-770d-9576-5f44ebb944f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crunch.com/locations/el-paso-dyer",
      "poi_directions_map_url": "https://maps.google.com/?cid=1674348033972161344&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---el-paso-dyer",
      "poi_latitude": "31.8722149",
      "poi_longitude": "-106.4278235",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-455-0044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7aPFYLpR54YRQMtIc6p6PBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6caca1f0-a32a-44f9-bf4d-d553aa90ff44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10861 Gateway N Blvd, El Paso, TX 79934, USA",
      "poi_short_description": "Chain fitness center with a large number of cardio machines offering tanning services.",
      "poi_long_description": "People say this gym offers a wide variety of machines and equipment, and the facilities are clean. They also highlight the friendly staff and the spacious layout, which prevents overcrowding.\n\nSome reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-dcf0-72f5-a576-99338274fb80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-dcf0-72f5-a576-99338274fb80",
        "storage_key": "property/6767906449165618/019cfb44-dcf0-72f5-a576-99338274fb80.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/el-paso-us-54-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2170976287987359036&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "31.9276247",
      "poi_longitude": "-106.4341826",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-822-1002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX4iDwfJT54YRPF1IfW7bIB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_735d1b6e-56e1-4804-a033-1a124644069b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10060 Rushing Rd, El Paso, TX 79924, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-dd67-71f8-8824-705f441fb168.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-dd67-71f8-8824-705f441fb168",
        "storage_key": "property/6767906449165618/019cfb44-dd67-71f8-8824-705f441fb168.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/tx/el-paso-transmountain/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15265030471792607421&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "31.9011184",
      "poi_longitude": "-106.4194099",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-315-2216",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPe3TbtHw24ARvUC2JFZI2NM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_cabda04f-db04-4b51-8be3-1b2cc9f64ca7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "10771 Gateway S Blvd Bldg F, El Paso, TX 79934, USA",
      "poi_short_description": "",
      "poi_long_description": "Some people say this cosmetics store has a wide selection of products.\n\nOther reviews mention the customer service can be poor and unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-ddc1-740f-bdfd-7f8262b964cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-ddc1-740f-bdfd-7f8262b964cd",
        "storage_key": "property/6767906449165618/019cfb44-ddc1-740f-bdfd-7f8262b964cd.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/el-paso-tx-1858",
      "poi_directions_map_url": "https://maps.google.com/?cid=11803926795260026656&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "31.9250338",
      "poi_longitude": "-106.4383169",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-294-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX-Z_gPhT54YRIF8wYuH4z6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_f21175eb-aec7-434a-90a0-0c3473453998",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Northeast Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "9405 Dyer St, El Paso, TX 79924, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-de3a-7316-8939-a9b1c8a16024.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-de3a-7316-8939-a9b1c8a16024",
        "storage_key": "property/6767906449165618/019cfb44-de3a-7316-8939-a9b1c8a16024.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://nevc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13500410042558193993&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northeast-veterinary-clinic",
      "poi_latitude": "31.8780214",
      "poi_longitude": "-106.4232292",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-755-2231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmaa4gTtR54YRSSHMzGcXW7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_5437dad0-8243-4f59-812c-ce7b9e0c7730",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Biggs Physical Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "11251 Ssg Sims St, Fort Bliss, TX 79908, USA",
      "poi_short_description": "Fitness center offering cardio and weight machines, a sauna, and basketball.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-decd-76e8-8672-c85fde31755c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-decd-76e8-8672-c85fde31755c",
        "storage_key": "property/6767906449165618/019cfb44-decd-76e8-8672-c85fde31755c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bliss.armymwr.com/programs/biggs-physical-fitness-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=5130268264761164378&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "biggs-physical-fitness-center",
      "poi_latitude": "31.83090529999999",
      "poi_longitude": "-106.3872678",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-744-8730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJozFu73tQ54YRWoKMM85fMkc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f1107d98-dbc8-47ab-b5a3-6b935d04d2cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Border City Basketball",
      "poi_type": "Health and Wellness",
      "poi_address": "6301 Alabama St, El Paso, TX 79904, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-df3e-73ef-ba65-7edd72706ced.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-df3e-73ef-ba65-7edd72706ced",
        "storage_key": "property/6767906449165618/019cfb44-df3e-73ef-ba65-7edd72706ced.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://border-city-basketball.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4902639241785861506&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "border-city-basketball",
      "poi_latitude": "31.8345052",
      "poi_longitude": "-106.4572436",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTbussfJX54YRgmWJRGqsCUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4cadefc3-905b-44a7-bede-d8a884386bfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "1617 Pleasonton Rd Ste G123, Fort Bliss, TX 79906, USA",
      "poi_short_description": "Chain salon offering haircuts for men, women, and kids, plus online check-ins.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-df84-70c4-8ae4-a003a482844b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-df84-70c4-8ae4-a003a482844b",
        "storage_key": "property/6767906449165618/019cfb44-df84-70c4-8ae4-a003a482844b.webp",
        "width": 888,
        "height": 500
      },
      "poi_business_url": "https://salons.greatclips.com/us/tx/fort-bliss/1617-pleasonton-rd?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4721678379832203902&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "31.81673679999999",
      "poi_longitude": "-106.4275757",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-225-2464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIY0nZAha54YRflqKTXjFhkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_7f98958b-419c-4b5e-98c4-efe436601d8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Glam Nails & Lash",
      "poi_type": "Health and Wellness",
      "poi_address": "9584 Dyer St Suite A, El Paso, TX 79924, USA",
      "poi_short_description": "Nail salon also offering eyelash extensions, teeth whitening, massages, and hairstyling services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-df96-72d7-9241-ff758063b0f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-df96-72d7-9241-ff758063b0f2",
        "storage_key": "property/6767906449165618/019cfb44-df96-72d7-9241-ff758063b0f2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://glam-nails-lash.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=809252491694127735&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glam-nails--lash",
      "poi_latitude": "31.88568819999999",
      "poi_longitude": "-106.4171691",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-474-4050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5S1CYsxR54YRdzoHhdoKOws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_8fd16360-061a-4d23-b1b9-c9093e091a45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "El Paso VA Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5001 N Piedras St, El Paso, TX 79930, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-dfd3-77eb-8d5d-02998b5200c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-dfd3-77eb-8d5d-02998b5200c5",
        "storage_key": "property/6767906449165618/019cfb44-dfd3-77eb-8d5d-02998b5200c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elpaso.va.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10344771763998139557&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-va-medical-center",
      "poi_latitude": "31.8206751",
      "poi_longitude": "-106.4624915",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 915-564-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9b2-723d-a78f-b093eb049191.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9b2-723d-a78f-b093eb049191",
        "storage_key": "property/6767906449165618/019cfb44-e9b2-723d-a78f-b093eb049191.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT9ynd7BZ54YRpaSZQxwDkI8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_65efe073-1c35-4bae-ba71-4031410b7c75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "The Hospitals of Providence Northeast Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "11274 McCombs St, El Paso, TX 79934, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e025-70dc-a0d4-62c0d7232823.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-e025-70dc-a0d4-62c0d7232823",
        "storage_key": "property/6767906449165618/019cfb44-e025-70dc-a0d4-62c0d7232823.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.thopemergency.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1871217079819131737&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-hospitals-of-providence-northeast-campus",
      "poi_latitude": "31.9378844",
      "poi_longitude": "-106.4071304",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-242-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9bd-73e8-8a95-20a0bbb9fbee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9bd-73e8-8a95-20a0bbb9fbee",
        "storage_key": "property/6767906449165618/019cfb44-e9bd-73e8-8a95-20a0bbb9fbee.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5cMTYjJT54YRWVtDHAXm9xk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a897c935-5153-4874-befb-e59ce05f475b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Franklin Mountains State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2900 Tom Mays Park Access Rd, El Paso, TX 79911, USA",
      "poi_short_description": "Vast state park featuring caves to explore, mountain trails and an amphitheater.",
      "poi_long_description": "People say this state park offers well-maintained hiking trails with breathtaking views, and opportunities for bird watching, picnicking, and camping. They highlight the easy and quick payment process for fees and parking, and the availability of picnic areas. They also like the friendly and helpful staff at the visitor center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e10e-74f0-bce9-5ecc7cbd2635.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-e10e-74f0-bce9-5ecc7cbd2635",
        "storage_key": "property/6767906449165618/019cfb44-e10e-74f0-bce9-5ecc7cbd2635.webp",
        "width": 1280,
        "height": 962
      },
      "poi_business_url": "https://tpwd.texas.gov/state-parks/franklin-mountains",
      "poi_directions_map_url": "https://maps.google.com/?cid=2199656840794880227&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "franklin-mountains-state-park",
      "poi_latitude": "31.9105609",
      "poi_longitude": "-106.518116",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-444-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c8-760c-bdbe-4c34121bd124.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c8-760c-bdbe-4c34121bd124",
        "storage_key": "property/6767906449165618/019cfb44-e9c8-760c-bdbe-4c34121bd124.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRc0ThtdV54YR4zhWDz7Ahh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_a3da2f3c-0292-41bc-9373-4eec2293207d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Veterans Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5301 Salem Dr, El Paso, TX 79924, USA",
      "poi_short_description": "Relaxed park featuring lots of sporting facilities alongside a playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e10e-74f0-bce9-592b0346e0b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-e10e-74f0-bce9-592b0346e0b5",
        "storage_key": "property/6767906449165618/019cfb44-e10e-74f0-bce9-592b0346e0b5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.elpasotexas.gov/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=5345773087273881718&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "veterans-park",
      "poi_latitude": "31.91980419999999",
      "poi_longitude": "-106.4213493",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-821-8909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c8-760c-bdbe-4c34121bd124.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c8-760c-bdbe-4c34121bd124",
        "storage_key": "property/6767906449165618/019cfb44-e9c8-760c-bdbe-4c34121bd124.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdSxihehT54YRdpDNvEwAMEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3a506a5f-5522-46d3-8ab2-b9409209143c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Painted Dunes Desert Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12000 McCombs St, El Paso, TX 79934, USA",
      "poi_short_description": "Desert golf course designed by Ken Dye and Jeffrey Brauer with 27 championship holes.",
      "poi_long_description": "People say this public golf course offers three challenging and fun courses with well-maintained tee boxes, fairways, and greens. They highlight the beautiful views, enjoyable layout, and well-organized play, even when busy. They also like the friendly, helpful, and courteous staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e192-7359-8ef0-3bbef65dfb6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-e192-7359-8ef0-3bbef65dfb6f",
        "storage_key": "property/6767906449165618/019cfb44-e192-7359-8ef0-3bbef65dfb6f.webp",
        "width": 1280,
        "height": 1011
      },
      "poi_business_url": "http://www.painteddunes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14140452292535456148&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "painted-dunes-desert-golf-course",
      "poi_latitude": "31.9564533",
      "poi_longitude": "-106.4046249",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-821-2122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9bd-73e8-8a95-1ec49ecda94a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9bd-73e8-8a95-1ec49ecda94a",
        "storage_key": "property/6767906449165618/019cfb44-e9bd-73e8-8a95-1ec49ecda94a.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJCxfRsglT54YRlBHv03D6PMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_207290b9-1330-4d7d-94a9-e0720d6df9b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Joey Barraza and Vino Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11270 McCombs St, El Paso, TX 79934, USA",
      "poi_short_description": "Spacious park featuring ball fields, playgrounds and a dog park.",
      "poi_long_description": "People say this park offers a dog park, playground, and soccer fields. They highlight the dog park has separate areas for different dog sizes, water stations, and poop bags, and the playground has a variety of activities suitable for different ages and abilities. They also like the spacious parking and the clean, green, and comfortable environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e2ca-76ab-879e-4f1a765f087e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-e2ca-76ab-879e-4f1a765f087e",
        "storage_key": "property/6767906449165618/019cfb44-e2ca-76ab-879e-4f1a765f087e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.businessyab.com/explore/united_states/texas/el_paso_county/el_paso/northeast_el_paso/mccombs_street/11270/joey-barraza-and-vino-memorial-park-915-212-0092.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=4162368882753704390&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "joey-barraza-and-vino-memorial-park",
      "poi_latitude": "31.9365332",
      "poi_longitude": "-106.403046",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c8-760c-bdbe-4c34121bd124.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c8-760c-bdbe-4c34121bd124",
        "storage_key": "property/6767906449165618/019cfb44-e9c8-760c-bdbe-4c34121bd124.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMRbzE7dT54YRxpGsGHK0wzk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_04e364f1-8a94-4bc2-89d7-c3c549895bcf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Skyline Optimist Youth Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5050 Yvette Ave, El Paso, TX 79924, USA",
      "poi_short_description": "Recreational area featuring picnic tables, a playground, baseball fields, and basketball and tennis courts.",
      "poi_long_description": "People say this park offers well-maintained baseball fields, pickleball courts, tennis courts, and a playground. They highlight the spacious, clean, and green environment with plenty of parking. They also like the clean and stocked portable toilets.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e327-736c-b45d-f01ced77673b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-e327-736c-b45d-f01ced77673b",
        "storage_key": "property/6767906449165618/019cfb44-e327-736c-b45d-f01ced77673b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elpasotexas.gov/parks-and-recreation/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9478345246637154744&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "skyline-optimist-youth-park",
      "poi_latitude": "31.8933202",
      "poi_longitude": "-106.4251592",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-212-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c8-760c-bdbe-4c34121bd124.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c8-760c-bdbe-4c34121bd124",
        "storage_key": "property/6767906449165618/019cfb44-e9c8-760c-bdbe-4c34121bd124.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4da1gERR54YRuOFRjMjYiYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7f48d5ac-2c2f-4f88-82a2-070b0a0ddf6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Fort Bliss A/DACG",
      "poi_type": "Transportation & Transit",
      "poi_address": "Fort Bliss, TX 79918, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e327-736c-b45d-f57dfb973e79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-e327-736c-b45d-f57dfb973e79",
        "storage_key": "property/6767906449165618/019cfb44-e327-736c-b45d-f57dfb973e79.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://home.army.mil/hood/index.php/units-tenants/installation-transportation-office/arrivaldeparture-airfield-control-group-dacg",
      "poi_directions_map_url": "https://maps.google.com/?cid=10912390521258870755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-bliss-adacg",
      "poi_latitude": "31.8294155",
      "poi_longitude": "-106.4096364",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-568-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-ecc7-736c-8333-d37a45b17111.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-ecc7-736c-8333-d37a45b17111",
        "storage_key": "property/6767906449165618/019cfb44-ecc7-736c-8333-d37a45b17111.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJjx8btptQ54YR44f53VyZcJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_2704c9fa-e908-4c87-a326-43f2185a7c2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "1st Armored Division HQ",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Building, 11685 Sergeant Major Blvd, Fort Bliss, TX 79918, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e3d8-706c-9400-a19232d0a491.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-e3d8-706c-9400-a19232d0a491",
        "storage_key": "property/6767906449165618/019cfb44-e3d8-706c-9400-a19232d0a491.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18293497454630407581&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "1st-armored-division-hq",
      "poi_latitude": "31.8436437",
      "poi_longitude": "-106.3604065",
      "poi_miles_from_property": "11.1",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB8Ej9MlR54YRnQ3CCgOP3_0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4f571694-3249-4319-86f1-ea9777654203",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "2-1 Brigade Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "20500 Cold War Dr, El Paso, TX 79918, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e3e4-7210-8190-d764fc180c40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-e3e4-7210-8190-d764fc180c40",
        "storage_key": "property/6767906449165618/019cfb44-e3e4-7210-8190-d764fc180c40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2077298818751370437&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "2-1-brigade-headquarters",
      "poi_latitude": "31.8592937",
      "poi_longitude": "-106.3479456",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW4tgbSdQ54YRxZQDCEUM1Bw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cca888e5-307c-47f4-b853-3aa264acab25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Fort Bliss Rail Head",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Fort Bliss, TX 79918, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e3da-74ef-81a4-40373a684eba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-e3da-74ef-81a4-40373a684eba",
        "storage_key": "property/6767906449165618/019cfb44-e3da-74ef-81a4-40373a684eba.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15651963384532989349&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-bliss-rail-head",
      "poi_latitude": "31.8454972",
      "poi_longitude": "-106.4110003",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhSQlnexQ54YRpXWCRMXxNtk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6d590fd6-0c04-461a-92db-2f7dc8f6c2b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Rail Load Area",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3621 Rail Deployment, Fort Bliss, TX 79918, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e41d-750f-bc50-b97db31e2263.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-e41d-750f-bc50-b97db31e2263",
        "storage_key": "property/6767906449165618/019cfb44-e41d-750f-bc50-b97db31e2263.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16485717947882014751&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rail-load-area",
      "poi_latitude": "31.8482138",
      "poi_longitude": "-106.4108891",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMScl9utQ54YRHwjK5iAJyeQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_890206b6-73a1-4250-be6d-bb229874599d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "El Paso Regional Communications Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6055 Threadgill Ave, El Paso, TX 79924, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e548-74be-993f-f916597dc6ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb44-e548-74be-993f-f916597dc6ae",
        "storage_key": "property/6767906449165618/019cfb44-e548-74be-993f-f916597dc6ae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.elpasocounty911.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13082972250546183893&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-regional-communications-center",
      "poi_latitude": "31.8854369",
      "poi_longitude": "-106.3985086",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-562-3911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6hekgtR54YR1R4ZAPINkLU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b563b2d6-91f8-437b-8cfb-91559d128037",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Parkland Elementary",
      "poi_type": "Education",
      "poi_address": "6330 Deer Ave, El Paso, TX 79924, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.yisd.net/parklandelementary",
      "poi_directions_map_url": "https://maps.google.com/?cid=12484020795783615562&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "parkland-elementary",
      "poi_latitude": "31.9054527",
      "poi_longitude": "-106.3889698",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-434-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9b1-7546-bda9-b16ca0c0cb90",
        "storage_key": "property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLavAIntR54YRSpRFRcUmQK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_add11dc0-1be9-4a57-bf40-72fc0a09dcda",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Dolphin Terrace Elementary",
      "poi_type": "Education",
      "poi_address": "9790 Pickerel Dr, El Paso, TX 79924, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yisd.net/dolphinterrace",
      "poi_directions_map_url": "https://maps.google.com/?cid=10308589604900050780&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dolphin-terrace-elementary",
      "poi_latitude": "31.8910969",
      "poi_longitude": "-106.4037389",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-434-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9b1-7546-bda9-b16ca0c0cb90",
        "storage_key": "property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAaDXYHJR54YRXBda36B3D48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3ea9804e-91ac-4e99-ac6c-9bcb096142b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Terrace Hills Middle School",
      "poi_type": "Education",
      "poi_address": "4835 Blossom Ave, El Paso, TX 79924, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534103165534643657&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "terrace-hills-middle-school",
      "poi_latitude": "31.9050469",
      "poi_longitude": "-106.4300131",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-231-2120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9b1-7546-bda9-b16ca0c0cb90",
        "storage_key": "property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9z8SCldR54YRyaXKp2sU8q0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_f8f07874-e054-4a09-a17d-dd95107d6dd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Parkland Middle School",
      "poi_type": "Education",
      "poi_address": "6045 Nova Way, El Paso, TX 79924, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7912-c531-726e-9bc7-a5f38f2f5560.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c531-726e-9bc7-a5f38f2f5560",
        "storage_key": "property/6767906449165618/019d7912-c531-726e-9bc7-a5f38f2f5560.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://parklandmiddle.yisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1596156752385806072&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "parkland-middle-school",
      "poi_latitude": "31.8967832",
      "poi_longitude": "-106.3986923",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-434-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9b1-7546-bda9-b16ca0c0cb90",
        "storage_key": "property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSZcBInFR54YR-A7MBxywJhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6cd7027a-3b99-4b56-ab5e-1bfdf6c7e99d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Parkland High School",
      "poi_type": "Education",
      "poi_address": "5932 Quail Ave, El Paso, TX 79924, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7912-c310-7056-ab16-2db238e3a7cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c310-7056-ab16-2db238e3a7cd",
        "storage_key": "property/6767906449165618/019d7912-c310-7056-ab16-2db238e3a7cd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.yisd.net/parklandhigh",
      "poi_directions_map_url": "https://maps.google.com/?cid=3670123650498804361&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "parkland-high-school",
      "poi_latitude": "31.9015435",
      "poi_longitude": "-106.4015686",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-434-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9b1-7546-bda9-b16ca0c0cb90",
        "storage_key": "property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMa7_I3tR54YRibq91QPm7jI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_32cf6456-e457-47c6-9f23-4c5fe3827342",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Andress High School",
      "poi_type": "Education",
      "poi_address": "5400 Sun Valley Dr, El Paso, TX 79924, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7912-c480-7134-99e9-cc13c8cc3049.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c480-7134-99e9-cc13c8cc3049",
        "storage_key": "property/6767906449165618/019d7912-c480-7134-99e9-cc13c8cc3049.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.episd.org/o/ahs",
      "poi_directions_map_url": "https://maps.google.com/?cid=16806702021355742915&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "andress-high-school",
      "poi_latitude": "31.9103819",
      "poi_longitude": "-106.4171107",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-236-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9b1-7546-bda9-b16ca0c0cb90",
        "storage_key": "property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-zruIWBR54YRw6a_VHFmPek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_b4573858-7ec2-4631-80e3-0af9d5f77c89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Transmountain Early College High School",
      "poi_type": "Education",
      "poi_address": "9570 Gateway Blvd N, El Paso, TX 79924, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7912-c1b5-73d2-a0ae-c2c4da155114.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c1b5-73d2-a0ae-c2c4da155114",
        "storage_key": "property/6767906449165618/019d7912-c1b5-73d2-a0ae-c2c4da155114.webp",
        "width": 600,
        "height": 261
      },
      "poi_business_url": "https://www.episd.org/tmechs",
      "poi_directions_map_url": "https://maps.google.com/?cid=4469076188752141114&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "transmountain-early-college-high-school",
      "poi_latitude": "31.8843717",
      "poi_longitude": "-106.4382406",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-236-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9b1-7546-bda9-b16ca0c0cb90",
        "storage_key": "property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ46lwtUpR54YROlu6kB1ZBT4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_cd37bef7-5409-425c-aa40-07d81d37c558",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Northeast Christian Academy",
      "poi_type": "Education",
      "poi_address": "9901 McCombs St, El Paso, TX 79924, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7912-ce90-7718-bc5d-777cf4b8cba8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-ce90-7718-bc5d-777cf4b8cba8",
        "storage_key": "property/6767906449165618/019d7912-ce90-7718-bc5d-777cf4b8cba8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.northeastcrusaders.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15183002167679776697&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "northeast-christian-academy",
      "poi_latitude": "31.8948357",
      "poi_longitude": "-106.4071986",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-755-1155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9b1-7546-bda9-b16ca0c0cb90",
        "storage_key": "property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP-dFDW5R54YRufeJTAfctNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_a7b66c40-d3d2-4cd1-ad30-37e29ca6c8cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Western Technical College - Diana Campus",
      "poi_type": "Education",
      "poi_address": "9451 Diana Dr, El Paso, TX 79924, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7912-cd04-72bd-b6d2-737151bbd2dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-cd04-72bd-b6d2-737151bbd2dd",
        "storage_key": "property/6767906449165618/019d7912-cd04-72bd-b6d2-737151bbd2dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.westerntech.edu/?utm_source=GMBlisting&utm_medium=Organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6133332257566644975&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "western-technical-college-diana-campus",
      "poi_latitude": "31.8777534",
      "poi_longitude": "-106.4259407",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-225-5984",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9b1-7546-bda9-b16ca0c0cb90",
        "storage_key": "property/6767906449165618/019cfb44-e9b1-7546-bda9-b16ca0c0cb90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ64MdTjpR54YR71q0RTH5HVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d122b025-94e8-4902-a03c-f795b6cb74d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Restaurants",
      "poi_address": "10765 Kenworthy St, El Paso, TX 79924, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7912-d823-763d-bb06-efd7b0a41c61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d823-763d-bb06-efd7b0a41c61",
        "storage_key": "property/6767906449165618/019d7912-d823-763d-bb06-efd7b0a41c61.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/1020356",
      "poi_directions_map_url": "https://maps.google.com/?cid=4611023247345013687&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks",
      "poi_latitude": "31.9205886",
      "poi_longitude": "-106.4380223",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-821-2006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7913-0fa2-7333-abc5-371637f7ae6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-0fa2-7333-abc5-371637f7ae6e",
        "storage_key": "property/6767906449165618/019d7913-0fa2-7333-abc5-371637f7ae6e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ8Y0IFgxT54YRt1MRlTal_T8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_41dfe6ac-3650-4fc4-af8e-6678cdc102ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Tropical Smoothie Cafe",
      "poi_type": "Restaurants",
      "poi_address": "4830 Woodrow Bean Transmountain Suite B, El Paso, TX 79924, USA",
      "poi_short_description": "Health-conscious cafe chain featuring a menu of custom smoothies, sandwiches & wraps.",
      "poi_long_description": "People say this juice shop offers delicious smoothies and bowls.\n\nOther reviews mention the service can be slow and the staff can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7912-d429-772a-a454-2ff28ab9878f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d429-772a-a454-2ff28ab9878f",
        "storage_key": "property/6767906449165618/019d7912-d429-772a-a454-2ff28ab9878f.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "https://locations.tropicalsmoothiecafe.com/tx/el-paso/4830-woodrow-bean-transmountain-drive?y_source=1_NDA4MzkxMDUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4692551106686533019&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tropical-smoothie-cafe",
      "poi_latitude": "31.89819",
      "poi_longitude": "-106.430801",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-412-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9ec-720e-b9a9-6f717cf43599",
        "storage_key": "property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc10UzQtR54YRm71qjF5KH0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "juice_shop"
    },
    {
      "id": "custom_f9c79463-97fc-4079-b5d5-aec2de8e5e98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Grove Brunch Cafe",
      "poi_type": "Restaurants",
      "poi_address": "9800 Gateway N Blvd Suite A, El Paso, TX 79924, USA",
      "poi_short_description": "Laid-back spot serving breakfast and lunch fare, as well as beer and cocktails.",
      "poi_long_description": "People say this restaurant serves delicious chilaquiles, French toast sandwiches, and a variety of other brunch options. They highlight the generous portions, fresh ingredients, and flavorful dishes, as well as the attentive and friendly service. They also like the welcoming and relaxed atmosphere, and the attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7912-d96e-74a9-a2c8-f8dbaf5555c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d96e-74a9-a2c8-f8dbaf5555c3",
        "storage_key": "property/6767906449165618/019d7912-d96e-74a9-a2c8-f8dbaf5555c3.webp",
        "width": 855,
        "height": 1280
      },
      "poi_business_url": "http://groveelpaso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8518579004727043290&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "grove-brunch-cafe",
      "poi_latitude": "31.8933568",
      "poi_longitude": "-106.4400148",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-500-1881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9ec-720e-b9a9-6f717cf43599",
        "storage_key": "property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYShJ4mNR54YR2iTbr3gSOHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e978d76b-aad7-4ed5-8bbe-51e9226e9a1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Dutch Bros Coffee",
      "poi_type": "Restaurants",
      "poi_address": "4810 Woodrow Bean Transmountain, El Paso, TX 79924, USA",
      "poi_short_description": "Fun-loving drive-thru serving up customized coffees, Rebel energy drinks, cold brew, tea & more.",
      "poi_long_description": "People say this coffee shop offers a wide variety of coffee and non-coffee drinks, including sugar-free and decaf options. They highlight the friendly, upbeat, and welcoming vibe, and the staff's attentiveness and speed in preparing orders. They also like the staff's willingness to make drinks to order and provide recommendations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7912-e280-7148-ae61-a9fce4e71636.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e280-7148-ae61-a9fce4e71636",
        "storage_key": "property/6767906449165618/019d7912-e280-7148-ae61-a9fce4e71636.webp",
        "width": 959,
        "height": 1280
      },
      "poi_business_url": "https://www.dutchbros.com/locations/tx/el-paso/4810-woodrow-bean-transmountain?y_source=1_NTgwMDE3NzItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15417128830729363241&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dutch-bros-coffee",
      "poi_latitude": "31.8980658",
      "poi_longitude": "-106.4317921",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 877-899-2767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7913-0fa2-7333-abc5-371637f7ae6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-0fa2-7333-abc5-371637f7ae6e",
        "storage_key": "property/6767906449165618/019d7913-0fa2-7333-abc5-371637f7ae6e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJEUfhHCFR54YRKZ8O9Pyk9NU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_e870dce2-0fd1-4636-b22c-6a848306f7c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "4640 Woodrow Bean Transmountain, El Paso, TX 79924, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "People say this fast food restaurant serves fresh hamburgers made to order. They also highlight the prompt and courteous service, and the generous staff.\n\nOther reviews mention orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7912-e897-705f-9573-adab66f94b65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e897-705f-9573-adab66f94b65",
        "storage_key": "property/6767906449165618/019d7912-e897-705f-9573-adab66f94b65.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.whataburger.com/tx/el-paso/4640-woodrow-bean.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=9138363213793884300&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "31.89792529999999",
      "poi_longitude": "-106.4359362",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-751-2958",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9ec-720e-b9a9-6f717cf43599",
        "storage_key": "property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg2QI02dR54YRjHiuAu380X4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_8636861b-f5ed-4a07-82bd-de8c12ac09c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "4525 Woodrow Bean Transmountain, El Paso, TX 79924, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "People say this restaurant serves great burgers, steaks, and fajitas. They also highlight the quick service, friendly staff, and delicious loaded mashed potatoes.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7912-e735-724a-8ab2-f7f87cd53b2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e735-724a-8ab2-f7f87cd53b2b",
        "storage_key": "property/6767906449165618/019d7912-e735-724a-8ab2-f7f87cd53b2b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.chilis.com/locations/us/texas/el-paso/transmountain?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=9817996179944610800&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chili-s-grill-bar",
      "poi_latitude": "31.899295",
      "poi_longitude": "-106.438816",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-757-3609",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9ec-720e-b9a9-6f717cf43599",
        "storage_key": "property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKdMsPFNR54YR8Ju994GHQIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d0c92a8c-50c1-4c4d-8026-c367b81221d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Noodles & Dumplings",
      "poi_type": "Restaurants",
      "poi_address": "4650 Woodrow Bean Transmountain, El Paso, TX 79924, USA",
      "poi_short_description": "Casual eats featuring braised beef noodle soup and combination fried rice, plus bao and sushi options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7912-eee2-7587-bbd1-fd8dff854c7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-eee2-7587-bbd1-fd8dff854c7d",
        "storage_key": "property/6767906449165618/019d7912-eee2-7587-bbd1-fd8dff854c7d.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://order.mealkeyway.com/customer/release/index?mid=2b47624a57457573754474525a376c334476446650413d3d",
      "poi_directions_map_url": "https://maps.google.com/?cid=12778699263187709521&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "noodles-dumplings",
      "poi_latitude": "31.8973104",
      "poi_longitude": "-106.4358439",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-926-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9ec-720e-b9a9-6f717cf43599",
        "storage_key": "property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCRAPtt9R54YRUW7ZgUYPV7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_13766f4c-634c-4700-b8da-04089665eb5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "4530 Woodrow Bean Transmountain, El Paso, TX 79924, USA",
      "poi_short_description": "Department store chain offering a wide selection of items, including electronics, apparel, and home furnishings.",
      "poi_long_description": "Shoppers say this department store is well-stocked with a wide variety of products, and they appreciate the helpful and friendly staff. They also highlight the convenient self-checkout option and ample parking.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7912-f549-724e-bac9-31ffacb4b298.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f549-724e-bac9-31ffacb4b298",
        "storage_key": "property/6767906449165618/019d7912-f549-724e-bac9-31ffacb4b298.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/500-el-paso-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13762258841261665114&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "31.8962902",
      "poi_longitude": "-106.4381376",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-757-0151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9bd-73e8-8a95-264f05fc9934.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9bd-73e8-8a95-264f05fc9934",
        "storage_key": "property/6767906449165618/019cfb44-e9bd-73e8-8a95-264f05fc9934.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8wljjlJR54YRWmthJIBd_b4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_8d306b56-2c48-495a-aafb-2b0a2998bade",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Sam's Club Bakery",
      "poi_type": "Shopping & Retail",
      "poi_address": "9498 Gateway N Blvd, El Paso, TX 79924, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7912-f69e-75ac-883a-34660749b52d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f69e-75ac-883a-34660749b52d",
        "storage_key": "property/6767906449165618/019d7912-f69e-75ac-883a-34660749b52d.webp",
        "width": 400,
        "height": 400
      },
      "poi_business_url": "https://www.samsclub.com/club/6246-el-paso-tx/bakery",
      "poi_directions_map_url": "https://maps.google.com/?cid=5111034862586829709&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sam-s-club-bakery",
      "poi_latitude": "31.8823184",
      "poi_longitude": "-106.4397061",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-730-6098",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9ec-720e-b9a9-6f717cf43599",
        "storage_key": "property/6767906449165618/019cfb44-e9ec-720e-b9a9-6f717cf43599.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__-bOTVR54YRjRsgyyAL7kY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_ea73bef8-c9c2-4a75-905a-3dc9c201eb77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "GameStop",
      "poi_type": "Shopping & Retail",
      "poi_address": "4650 Woodrow Bean Transmountain Ste. D1, El Paso, TX 79924, USA",
      "poi_short_description": "Chain retailer offering new & used video games, plus consoles, controllers & related gear.",
      "poi_long_description": "Chain retailer offering new & used video games, plus consoles, controllers & related gear.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7912-fc47-7058-8d2e-13af7faf060b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-fc47-7058-8d2e-13af7faf060b",
        "storage_key": "property/6767906449165618/019d7912-fc47-7058-8d2e-13af7faf060b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.gamestop.com/store/us/tx/el-paso/6925/desert-mountain-plaza-gamestop?utm_source=gmblisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=17751304810750133776&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gamestop",
      "poi_latitude": "31.8972718",
      "poi_longitude": "-106.4355405",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-751-7875",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9bd-73e8-8a95-264f05fc9934.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9bd-73e8-8a95-264f05fc9934",
        "storage_key": "property/6767906449165618/019cfb44-e9bd-73e8-8a95-264f05fc9934.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJkSXy0lNR54YREMZxyKxNWfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_82078ae8-a60f-46e2-9bdb-2a0092461010",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "10771 Gateway S Blvd, El Paso, TX 79934, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7912-ff19-77fc-9366-a3c4a471f5e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-ff19-77fc-9366-a3c4a471f5e1",
        "storage_key": "property/6767906449165618/019d7912-ff19-77fc-9366-a3c4a471f5e1.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.dollartree.com/locations/tx/el%20paso/6023/",
      "poi_directions_map_url": "https://maps.google.com/?cid=791375444091380499&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "31.9261183",
      "poi_longitude": "-106.4397801",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-995-7733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9bd-73e8-8a95-264f05fc9934.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9bd-73e8-8a95-264f05fc9934",
        "storage_key": "property/6767906449165618/019cfb44-e9bd-73e8-8a95-264f05fc9934.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwy7M9ZpT54YRE6MIBcaH-wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_c1d66b9b-897c-4ef4-827b-38a33e4cc91d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "10780 Kenworthy St Walgreens, El Paso, TX 79924, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7913-0054-7532-b956-c907b5c0a690.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0054-7532-b956-c907b5c0a690",
        "storage_key": "property/6767906449165618/019d7913-0054-7532-b956-c907b5c0a690.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-10780+kenworthy+st-el+paso-tx-79924/id=6543",
      "poi_directions_map_url": "https://maps.google.com/?cid=2840742267159744449&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "31.9224169",
      "poi_longitude": "-106.4384463",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-821-2698",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDbQTevZT54YRwY9-hApYbCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_bb082b93-62a5-45e0-9c70-5c6d2f729f2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "AMC El Paso 16",
      "poi_type": "Entertainment",
      "poi_address": "9840 Gateway N Blvd, El Paso, TX 79924, USA",
      "poi_short_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_long_description": "People say this movie theater offers a wide selection of movies and comfortable recliner seats. They also highlight the friendly and helpful staff, and the clean facilities.\n\nOther reviews mention the concessions can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7913-020f-73b7-b3e4-82890298d424.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-020f-73b7-b3e4-82890298d424",
        "storage_key": "property/6767906449165618/019d7913-020f-73b7-b3e4-82890298d424.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/el-paso/amc-el-paso-16?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=7621955250431156400&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amc-el-paso-16",
      "poi_latitude": "31.8944502",
      "poi_longitude": "-106.4374633",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-751-5613",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7913-111c-737c-b3e2-64ad3c616176.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-111c-737c-b3e2-64ad3c616176",
        "storage_key": "property/6767906449165618/019d7913-111c-737c-b3e2-64ad3c616176.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJFdvtcE1R54YRsGDf2-qfxmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_283d8fe1-2a8e-415d-9104-5245fd5ec5d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "McKelligon Canyon",
      "poi_type": "Entertainment",
      "poi_address": "McKelligon Canyon Rd, El Paso, TX 79930, USA",
      "poi_short_description": "Shaded picnic tables and a cave at this desert park featuring trails, an amphitheater and a show.",
      "poi_long_description": "People say this amphitheatre offers a cool place to watch concerts, with good food and drinks. They highlight the beautiful mountain and city views, and the relaxing and quiet vibe. They also like the challenging hills for hiking and training, and the easy access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7913-051f-779c-80dc-8312baf37bad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-051f-779c-80dc-8312baf37bad",
        "storage_key": "property/6767906449165618/019d7913-051f-779c-80dc-8312baf37bad.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://elpasolive.com/venues/mckelligon-canyon-amphitheatre",
      "poi_directions_map_url": "https://maps.google.com/?cid=17692196788310998967&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mckelligon-canyon",
      "poi_latitude": "31.8375278",
      "poi_longitude": "-106.4846943",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 915-534-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c7-75de-a0bc-0174d8eca8af",
        "storage_key": "property/6767906449165618/019cfb44-e9c7-75de-a0bc-0174d8eca8af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbeBU7mZX54YRt3-V3z1Ph_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_883f141b-f116-4732-ac20-75c215d738b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Sue Young Park",
      "poi_type": "Entertainment",
      "poi_address": "9730 Diana Dr, El Paso, TX 79924, USA",
      "poi_short_description": "Clean park featuring a playground with water features and splash pads.",
      "poi_long_description": "People say this city park offers a water park, playground, and soccer fields, and is a great place for families and children's birthday parties. They highlight the diverse diversions, the view of the mountains, and the convenient access from the freeway. They also like the well-maintained facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019d7913-0877-7366-9098-7241314f1e1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0877-7366-9098-7241314f1e1a",
        "storage_key": "property/6767906449165618/019d7913-0877-7366-9098-7241314f1e1a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11389328552087644248&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sue-young-park",
      "poi_latitude": "31.88379",
      "poi_longitude": "-106.4353732",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-e9c8-760c-bdbe-4c34121bd124.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-e9c8-760c-bdbe-4c34121bd124",
        "storage_key": "property/6767906449165618/019cfb44-e9c8-760c-bdbe-4c34121bd124.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkefn-zVR54YRWOhlkfkFD54",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_f9352667-554e-4c94-8dcb-29ff0aa4887a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "poi_name": "Collins Elementary School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "collins-elementary-school",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_3d49090211a08157068697ad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_95f89b3b50fcc0a58fede933",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_1d1bfe73c779b7584dee5d39",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_411630a8ae51b6722f1fe6cf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_5e66416365ce37c5d066e9e3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_9531f29ee58a1a8afede328d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_228ea9ef-5cfd-471b-ad52-453bd1cf49b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "rating": "5.0",
      "name": "Linda Collier",
      "text": "I wanna write a review thank you guys so much for helping me out and I have three special peoples that I want to get a kudos to the two maintenance persons or Dannie and Joe. We have the best staff on site. Management team Stephanie’s she is the best manager that I ever seen in my life. She works with you.  Anything you tell she right on it 😊 thank you so much 🥰",
      "date": "2025-10-06",
      "title": ""
    },
    {
      "id": "custom_0da048b6-5e2f-4a72-86a7-ea9e6a85a337",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "rating": "5.0",
      "name": "James Mayes",
      "text": "I have been a resident here for the past 3 years. The office staff is great. As a senior citizen, they understand we may limit computer skills. It is a good feeling to know they are always there for you . The maintenance staff Is wonderful. Not only do they respond to your request quickly they make sure you place is  left clean after the work is done.  I've been in El Paso for 30 years, lived in several places and this is the best so for. Keep up the good work. The staff is very knowledgeable, courteous and helpful and most important they let you know you made the right decision by moving here.",
      "date": "2025-07-13",
      "title": ""
    },
    {
      "id": "custom_0ac2d2cf-e6c2-4170-a4cd-ec9834e1d2b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "rating": "5.0",
      "name": "Kashif Pooser",
      "text": "The property is well kept. The main office personnel are great and knew the property, prices, and deals like the back of the hand. Love the on-site laundry facilities, the gym is always clean, the pool is well kept. Maintenance personnel are friendly and respectful. He knows what he's doing. He did not leave a mess at all. Keep up the good work!",
      "date": "2025-07-17",
      "title": ""
    },
    {
      "id": "custom_ff0a1ea7-7a11-4a96-803a-c077f80703d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "rating": "5.0",
      "name": "Linda Alexander",
      "text": "Maintenance came out quickly (after hours) to fix my AC that wasn’t cooling. Great service!",
      "date": "2025-10-02",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_9a0154f4-0ca3-4453-aeb7-d46773e8c27f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb45-9b5e-72ea-acdc-aa17d8003970.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of a swimming pool and lounge area at a multifamily property.",
        "public_id": "019cfb45-9b5e-72ea-acdc-aa17d8003970",
        "storage_key": "property/6767906449165618/019cfb45-9b5e-72ea-acdc-aa17d8003970.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Patriot Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f8f396dafdfe66b3bec1dcd"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-4f31-7031-8bc7-4399ca90c312",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "patriot-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618"
    },
    {
      "lead_collector_id": "019cf79e-4fa9-768b-82b1-e92546285462",
      "lead_source": "LANDING_PAGE",
      "name": "patriot-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-el-paso-tx-patriot",
      "search_query": "pet friendly apartments El Paso TX",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in El Paso, TX",
      "h2_subtitle": "Discover a welcoming home for you and your pet. Explore Patriot Apts., a community offering pet friendly apartments in the heart of El Paso, TX.",
      "page_copy": "Patriot Apts. embraces pet lovers by offering pet friendly apartments in El Paso, TX. Located in the scenic Terrace Hills neighborhood, our community is designed for you and your furry friend's comfort. With spacious floor plans ranging from one to three bedrooms, there's plenty of room to play and relax. Experience the convenience of modern amenities, including a fitness center and sparkling pool, that enhance your lifestyle.\n\nOur vibrant community understands the importance of a pet-friendly environment. At Patriot Apts., you’ll find ample green spaces and pet-oriented amenities that cater to your needs. Enjoy quality time with your pet while living in a welcoming and accommodating atmosphere. With maintenance on site and easy access to vital facilities, Patriot Apts. promises a seamless living experience for both you and your four-legged family members.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with autumn foliage.",
        "public_id": "019cfb44-c888-7629-b324-15d7074c4d90",
        "storage_key": "property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments El Paso, TX",
      "seo_description": "Explore pet friendly apartments at Patriot Apts. El Paso, TX. Enjoy a vibrant community perfect for you and your pet. Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-laundry-el-paso-patriot",
      "search_query": "apartments with in-unit laundry El Paso",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in El Paso",
      "h2_subtitle": "Experience modern living at Patriot Apts. offering apartments with in-unit laundry in El Paso. Enjoy convenience and comfort in every home.",
      "page_copy": "Welcome to Patriot Apts. in El Paso, where comfort meets convenience, including the benefit of apartments with in-unit laundry. Located in the charming Terrace Hills neighborhood, our community ensures a lifestyle that's both practical and luxurious. Each apartment, from cozy one-bedroom units to spacious three-bedroom layouts, is thoughtfully designed with you in mind.\n\nOur comprehensive amenities extend beyond the basics, featuring state-of-the-art laundry facilities to make your household chores easier. Enjoy the scenic surroundings and shared community spaces like our fitness center and swimming pool, which enhance the quality of life at Patriot Apts. Whether you're relaxing at home or exploring the vibrant neighborhood, Patriot Apts. is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with autumn foliage.",
        "public_id": "019cfb44-c888-7629-b324-15d7074c4d90",
        "storage_key": "property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry El Paso",
      "seo_description": "Patriot Apts. offers El Paso living with in-unit laundry. Discover comfort and modern convenience in a vibrant community. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "generator",
      "page_item_url": "apartments-with-air-conditioning-79924-patriot",
      "search_query": "apartments with air conditioning 79924",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in 79924",
      "h2_subtitle": "Enjoy cool comfort at Patriot Apts., offering apartments with air conditioning in the 79924 area. Relax in our temperature-controlled homes.",
      "page_copy": "Find your perfect haven at Patriot Apts., where you can experience ultimate comfort in apartments with air conditioning in the 79924 zip code. Nestled in the scenic Terrace Hills neighborhood of El Paso, our community combines convenience with essential temperature control, ensuring you can beat the Texas heat in style. Choose from one to three-bedroom layouts, each thoughtfully designed to enhance your living experience.\n\nBeyond air conditioning, Patriot Apts. provides a suite of modern amenities such as a fitness center, sparkling pool, and convenient pantry spaces. Our pet-friendly community welcomes you and your four-legged friends to enjoy a vibrant and serene living environment. With on-site maintenance and prime location, you're bound to find everything you need at Patriot Apts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with autumn foliage.",
        "public_id": "019cfb44-c888-7629-b324-15d7074c4d90",
        "storage_key": "property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments 79924",
      "seo_description": "Stay cool at Patriot Apts. El Paso 79924 with air-conditioned apartments and convenient amenities. Schedule your tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "generator",
      "page_item_url": "el-paso-apartments-with-swimming-pool-patriot",
      "search_query": "El Paso apartments with swimming pool",
      "category": "Amenity",
      "h1_title": "El Paso Apartments with Swimming Pool",
      "h2_subtitle": "Dive into luxury at Patriot Apts., featuring El Paso apartments with a sparkling swimming pool. Refresh and relax in style.",
      "page_copy": "At Patriot Apts., residents can enjoy a refreshing lifestyle with our El Paso apartments featuring a sparkling swimming pool. Nestled in the Terrace Hills neighborhood, our community offers a serene escape from the city's hustle and bustle. Choose from inviting one to three-bedroom floor plans, all providing modern comforts and amenities that cater to your every need.\n\nWhether you’re looking to cool off on a hot day or enjoy a leisurely swim, our swimming pool area serves as a fantastic retreat. Alongside the pool, residents benefit from a suite of services and conveniences, including a fitness center, pet-friendly policies, and on-site maintenance. Patriot Apts. is more than just a place to live; it’s a community where you can thrive and make lasting memories.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with autumn foliage.",
        "public_id": "019cfb44-c888-7629-b324-15d7074c4d90",
        "storage_key": "property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "El Paso Apartments with Swimming Pool",
      "seo_description": "Explore Patriot Apts. in El Paso, offering apartments with a luxurious swimming pool. Dive into comfort and convenience today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "generator",
      "page_item_url": "terrace-hills-fitness-center-apartments-patriot",
      "search_query": "Terrace Hills fitness center apartments",
      "category": "Amenity",
      "h1_title": "Terrace Hills Fitness Center Apartments",
      "h2_subtitle": "Stay active at Patriot Apts., offering Terrace Hills apartments with a modern fitness center. Enjoy a healthy lifestyle in El Paso.",
      "page_copy": "Welcome to Patriot Apts., where staying active is easy in our fitness center-equipped Terrace Hills apartments. Located in the vibrant heart of El Paso, our community provides residents the perfect blend of comfort and wellness. Our spacious one to three-bedroom apartments are complemented by a state-of-the-art fitness facility that encourages a healthy and active lifestyle.\n\nThe modern fitness center is just one of the many features residents love. With a sparkling pool, pet-friendly spaces, and on-site maintenance, Patriot Apts. ensures every need is met. Positioned in the tranquil Terrace Hills neighborhood, you’ll find an inviting and community-oriented atmosphere. Join us at Patriot Apts. and discover living redefined.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with autumn foliage.",
        "public_id": "019cfb44-c888-7629-b324-15d7074c4d90",
        "storage_key": "property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Terrace Hills Fitness Center Apartments",
      "seo_description": "Live in El Paso’s Terrace Hills at Patriot Apts. with a top-tier fitness center. Enjoy comfort and convenience. Schedule a visit!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-el-paso-tx-patriot",
      "search_query": "one bedroom apartments el paso tx",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in El Paso, TX",
      "h2_subtitle": "Discover the ideal one bedroom apartments at Patriot Apts. in El Paso, TX. Perfect for singles or couples seeking comfort and style.",
      "page_copy": "Experience the charm of El Paso, TX, with the perfect one bedroom apartment at Patriot Apts. Our community is designed to cater to your lifestyle needs, offering a variety of amenities that enhance everyday living. Situated in the Terrace Hills neighborhood, our one-bedroom apartments provide a cozy haven with modern touches, from the well-equipped kitchen to spacious living areas.\n\nPatriot Apts. stands out with its dedication to comfort and community. Enjoy the benefits of our sparkling swimming pool, fitness center, and pet-friendly policies, all aimed at providing a superior living experience. Whether you’re new to El Paso or looking for a fresh start, our one-bedroom homes offer a perfect blend of convenience and tranquility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with autumn foliage.",
        "public_id": "019cfb44-c888-7629-b324-15d7074c4d90",
        "storage_key": "property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments El Paso, TX",
      "seo_description": "Find your perfect one bedroom apartment at Patriot Apts. El Paso, TX. Enjoy modern amenities and a welcoming community. Inquire today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-terrace-hills-patriot",
      "search_query": "two bedroom apartments near terrace hills",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Terrace Hills",
      "h2_subtitle": "Explore spacious two bedroom apartments near Terrace Hills at Patriot Apts. Ideal for families or roommates looking for comfort and amenities.",
      "page_copy": "Discover the spacious two bedroom apartments near Terrace Hills at Patriot Apts. Perfectly situated in El Paso, our community offers an exceptional living experience enriched by top-tier amenities. Whether you’re a growing family or roommates seeking ample space, our floor plans provide the perfect balance of comfort and style with room to live and room to grow.\n\nPatriot Apts. goes beyond just living space. With access to a sparkling pool, a modern fitness center, and pet-friendly areas, everything you need is right at your doorstep. Nestled in the charming Terrace Hills neighborhood, you'll enjoy a tranquil environment without sacrificing proximity to urban conveniences. Choose Patriot Apts. as your next home and experience vibrant community living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with autumn foliage.",
        "public_id": "019cfb44-c888-7629-b324-15d7074c4d90",
        "storage_key": "property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Terrace Hills",
      "seo_description": "Find spacious two bedroom apartments near Terrace Hills at Patriot Apts. Enjoy modern amenities and vibrant community living in El Paso.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-in-79924-patriot",
      "search_query": "three bedroom apartments in 79924",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in 79924",
      "h2_subtitle": "Patriot Apts. offers expansive three bedroom apartments in the 79924 area. Ideal for larger households seeking space and convenience in El Paso.",
      "page_copy": "Welcome to Patriot Apts., where you'll find expansive three bedroom apartments in the 79924 area of El Paso. Exquisitely designed for families and larger households, our homes provide roomy interiors and modern amenities that cater to your lifestyle needs. Each apartment features well-appointed spaces including modern kitchens, inviting living rooms, and ample storage areas, ensuring comfort and convenience.\n\nLiving at Patriot Apts. not only gives you a spacious home but also access to community-enhancing features like a sparkling pool, a comprehensive fitness center, and pet-friendly zones. Located in the vibrant Terrace Hills neighborhood, our community offers a friendly atmosphere and seamless access to the best that El Paso has to offer. Discover your ideal home today at Patriot Apts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with autumn foliage.",
        "public_id": "019cfb44-c888-7629-b324-15d7074c4d90",
        "storage_key": "property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in 79924",
      "seo_description": "Discover spacious three bedroom apartments in 79924 at Patriot Apts. Enjoy modern living with top-tier amenities. Ideal for El Paso families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "generator",
      "page_item_url": "apartments-near-epcc-transmountain-el-paso-patriot",
      "search_query": "apartments near EPCC Transmountain El Paso",
      "category": "School",
      "h1_title": "Apartments Near EPCC Transmountain El Paso",
      "h2_subtitle": "Discover convenient apartments near EPCC Transmountain at Patriot Apts. Ideal for students and professionals seeking a convenient El Paso location.",
      "page_copy": "Patriot Apts. offers stylish and convenient living with apartments near EPCC Transmountain in El Paso. Our location is perfect for students and professionals who appreciate a short commute and easy access to educational facilities. Living here means you can enjoy the benefits of modern amenities while being close to campus life and academic resources.\n\nOur community in the Terrace Hills neighborhood boasts exceptional features such as a fitness center, sparkling pool, and pet-friendly areas, ensuring a balanced lifestyle. With various floor plans available, including one, two, and three-bedroom options, Patriot Apts. is the ideal choice for anyone looking to combine comfort and convenience near EPCC Transmountain.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with autumn foliage.",
        "public_id": "019cfb44-c888-7629-b324-15d7074c4d90",
        "storage_key": "property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near EPCC Transmountain El Paso",
      "seo_description": "Find ideal apartments near EPCC Transmountain at Patriot Apts. El Paso offers modern amenities and a convenient location for students and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "generator",
      "page_item_url": "apartments-near-el-paso-va-medical-center-patriot",
      "search_query": "apartments near El Paso VA Medical Center",
      "category": "Hospital",
      "h1_title": "Apartments Near El Paso VA Medical Center",
      "h2_subtitle": "Find ideal apartments near El Paso VA Medical Center at Patriot Apts. Convenient living for healthcare staff and veterans in a vibrant community.",
      "page_copy": "Discover Patriot Apts., the ideal choice for those seeking apartments near El Paso VA Medical Center. Situated in the Terrace Hills neighborhood, our community provides a perfect balance of convenience and modern living. These well-designed apartments are suited for healthcare professionals, veterans, and anyone wanting proximity to the medical center while enjoying access to exceptional amenities.\n\nResidents of Patriot Apts. benefit from features such as an on-site fitness center, a sparkling pool, and pet-friendly areas, making it easy to unwind after a busy day. With a variety of one, two, and three-bedroom floor plans available, you can find the perfect home that fits your lifestyle while being just minutes away from the El Paso VA Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with autumn foliage.",
        "public_id": "019cfb44-c888-7629-b324-15d7074c4d90",
        "storage_key": "property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near El Paso VA Medical Center",
      "seo_description": "Find perfect apartments near El Paso VA Medical Center at Patriot Apts. Enjoy modern living and convenient access for healthcare workers and veterans.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "generator",
      "page_item_url": "terrace-hills-apartments-near-hospitals-providence",
      "search_query": "Terrace Hills apartments close to The Hospitals of Providence Northeast Campus",
      "category": "Hospital",
      "h1_title": "Terrace Hills Apartments Near Hospitals",
      "h2_subtitle": "Explore Terrace Hills apartments close to The Hospitals of Providence Northeast Campus. Convenient living with all essential amenities in El Paso.",
      "page_copy": "Nestled in the Terrace Hills neighborhood, Patriot Apts. offers ideal apartments close to The Hospitals of Providence Northeast Campus. If you're a healthcare professional or someone who values proximity to essential services, you'll find our location perfect for a convenient lifestyle. Our community combines the serenity of suburban living with immediate access to healthcare facilities.\n\nChoose from our variety of spacious floor plans, each equipped with modern amenities designed for comfort and ease. Residents enjoy on-site features such as a fitness center, a sparkling pool, and pet-friendly areas, creating a welcoming environment. Experience the convenience and vibrant living at Patriot Apts. while being minutes away from your workplace.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with autumn foliage.",
        "public_id": "019cfb44-c888-7629-b324-15d7074c4d90",
        "storage_key": "property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Terrace Hills Apartments Near Hospitals",
      "seo_description": "Discover Terrace Hills apartments near The Hospitals of Providence Northeast in El Paso. Find perfect modern living close to where you work.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "generator",
      "page_item_url": "apartments-near-franklin-mountains-state-park-el-paso",
      "search_query": "apartments near Franklin Mountains State Park El Paso",
      "category": "Park",
      "h1_title": "Apartments Near Franklin Mountains State Park",
      "h2_subtitle": "Live near nature with apartments near Franklin Mountains State Park in El Paso. Outdoor enthusiasts will love this perfect location.",
      "page_copy": "Experience the best of outdoor living at Patriot Apts., situated near Franklin Mountains State Park in El Paso. Our community offers easy access to the park's breathtaking trails and natural beauty, making it an ideal home for nature lovers and outdoor enthusiasts. Immerse yourself in the serenity of the great outdoors while enjoying the comforts of modern living.\n\nAt Patriot Apts., we provide a variety of spacious floor plans, featuring fantastic amenities like a fitness center, a sparkling pool, and designated pet-friendly spaces. Whether you're embarking on a mountain adventure or relaxing at home, our apartments offer comfort and convenience. Discover how living near Franklin Mountains State Park combines the best of nature and modern life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with autumn foliage.",
        "public_id": "019cfb44-c888-7629-b324-15d7074c4d90",
        "storage_key": "property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Franklin Mountains State Park",
      "seo_description": "Find apartments near Franklin Mountains State Park at Patriot Apts. Ideal El Paso living for nature lovers seeking outdoor access and modern comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "generator",
      "page_item_url": "patriot-apts-close-to-veterans-park-tx",
      "search_query": "Patriot Apts. close to Veterans Park TX",
      "category": "Park",
      "h1_title": "Patriot Apts. Close to Veterans Park",
      "h2_subtitle": "Discover Patriot Apts. close to Veterans Park TX. Enjoy easy access to leisure activities and community events in El Paso.",
      "page_copy": "Located within close proximity to Veterans Park TX, Patriot Apts. offers an ideal living situation for those who cherish recreational activities and community events. Our community provides a unique blend of relaxation and social interaction, making it the perfect place for families, professionals, and retirees seeking to enjoy the vibrant atmosphere of Terrace Hills.\n\nPatriot Apts. boasts a selection of spacious floor plans catering to various lifestyle needs, complete with state-of-the-art amenities like a fitness center and a sparkling pool. Whether you're taking a leisurely stroll through Veterans Park or engaging with friends and neighbors at home, you'll find a welcoming environment at Patriot Apts. Experience the convenience and comfort of living in close vicinity to El Paso's recreational hubs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with autumn foliage.",
        "public_id": "019cfb44-c888-7629-b324-15d7074c4d90",
        "storage_key": "property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Patriot Apts. Close to Veterans Park",
      "seo_description": "Live at Patriot Apts., close to Veterans Park TX, and enjoy the perfect El Paso lifestyle with proximity to leisure activities and community events.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "generator",
      "page_item_url": "housing-near-joey-barraza-vino-memorial-park-el-paso",
      "search_query": "housing by Joey Barraza and Vino Memorial Park El Paso",
      "category": "Park",
      "h1_title": "Housing by Joey Barraza and Vino Memorial Park",
      "h2_subtitle": "Find housing by Joey Barraza and Vino Memorial Park in El Paso. Enjoy community recreation and natural beauty close to home.",
      "page_copy": "Situated near Joey Barraza and Vino Memorial Park, Patriot Apts. offers a prime location for individuals and families who enjoy outdoor activities and scenic beauty in El Paso. This tranquil housing option combines the comforts of modern living with convenient access to one of the city's cherished green spaces. Whether you're looking to unwind in nature or participate in community events, you'll find it all within reach.\n\nPatriot Apts. provides a range of spacious floor plans, each designed with modern amenities such as a well-equipped fitness center, a sparkling pool, and pet-friendly areas. This makes it a welcoming home for both relaxation and recreation. Embrace the vibrant lifestyle that comes with living near Joey Barraza and Vino Memorial Park and discover the perfect blend of comfort and connectivity.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with autumn foliage.",
        "public_id": "019cfb44-c888-7629-b324-15d7074c4d90",
        "storage_key": "property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing by Joey Barraza & Vino Memorial Park",
      "seo_description": "Discover housing near Joey Barraza and Vino Memorial Park, El Paso. Enjoy the blend of nature and community with modern living at Patriot Apts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165618",
      "source": "generator",
      "page_item_url": "nearby-apartments-skyline-optimist-youth-park-terrace-hills",
      "search_query": "nearby apartments to Skyline Optimist Youth Park Terrace Hills",
      "category": "Park",
      "h1_title": "Nearby Apartments to Skyline Optimist Youth Park",
      "h2_subtitle": "Explore nearby apartments to Skyline Optimist Youth Park in Terrace Hills. Ideal for families seeking outdoor fun and activities.",
      "page_copy": "Patriot Apts. offers nearby living options to Skyline Optimist Youth Park in Terrace Hills, perfect for families and individuals who cherish outdoor recreation and community involvement. With convenient access to one of El Paso's lively parks, residents can easily enjoy sports, playgrounds, and neighborhood events without traveling far from home. This location is ideal for those who value active community life.\n\nOur apartment community provides a diverse selection of one to three-bedroom layouts, featuring top-tier amenities like a fitness center, a sparkling pool, and laundry facilities. Living at Patriot Apts. means you’re never far from the action, whether attending park activities or relaxing in the comfort of home. Discover the joy of proximity to Skyline Optimist Youth Park and the conveniences of modern living in El Paso.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with autumn foliage.",
        "public_id": "019cfb44-c888-7629-b324-15d7074c4d90",
        "storage_key": "property/6767906449165618/019cfb44-c888-7629-b324-15d7074c4d90.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to Skyline Optimist Youth Park",
      "seo_description": "Find nearby apartments to Skyline Optimist Youth Park, Terrace Hills. Ideal El Paso living with park access and modern amenities at Patriot Apts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5195"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-N6YWWH05CZ"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151691"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/the-patriot-apartments/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KH8HKRKZ"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165618/019d1bd9-2a33-72ff-97e3-71a47f60fa7f.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8442932380"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "855-962-3699"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6480cd438b4d2861bc510121"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlBETkNYZnF5VEZvTDNCT2pUN1oyTFE9PSIsInZhbHVlIjoiNHpSSGNwajBIOG1vbE1FSngrQXdzQT09IiwibWFjIjoiZDIxZTAzMzdlNTkyMjc5OWE4MDFjYTZlNjY0MGY4YmYzNWNjMmI3MzViY2ZiZGYyYWZiNzJlZmU5Nzk5YzM5MSJ9"
    }
  ],
  "custom_qb_id": "5195",
  "custom_ga4_id": "G-N6YWWH05CZ",
  "custom_repli_id": "10041151691",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/the-patriot-apartments/register/",
  "custom_google_gtm_id": "GTM-KH8HKRKZ",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165618/019d1bd9-2a33-72ff-97e3-71a47f60fa7f.pdf",
  "custom_hubspot_company_id": "8442932380",
  "custom_ppc_tracking_phone_number": "855-962-3699",
  "custom_residentboost_apartment_id": "6480cd438b4d2861bc510121",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlBETkNYZnF5VEZvTDNCT2pUN1oyTFE9PSIsInZhbHVlIjoiNHpSSGNwajBIOG1vbE1FSngrQXdzQT09IiwibWFjIjoiZDIxZTAzMzdlNTkyMjc5OWE4MDFjYTZlNjY0MGY4YmYzNWNjMmI3MzViY2ZiZGYyYWZiNzJlZmU5Nzk5YzM5MSJ9"
};

export const generatedAt = '2026-08-27T21:37:20.218Z';
